import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import DefaultContainer from '@/containers/DefaultContainer.vue'
import CervettiDashboard from '@/views/CervettiDashboard.vue'

// Containers
// const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
/*
const Dashboard = () => import('@/views/Dashboard')
*/

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const ForgotPassword = () => import('@/views/pages/Forgot')
// const Register = () => import('@/views/pages/Register')
const LoginEmpresa = () => import('@/views/pages/LoginEmpresa')
const ResetPassword = () => import('@/views/pages/ResetPass')
const UpdatePassword = () => import('@/views/pages/Pass')
const Registro = () => import('@/views/pages/ResetPass')

// SGC
// const CervettiDashboard = () => import('@/views/CervettiDashboard')
// const DashboardCuentas = () => import('@/views/DashboardCuentas')
// const DashboardProduccion = () => import('@/views/DashboardProduccion')
// const DashboardDisenio = () => import('@/views/DashboardDisenio')

const Articulos = () => import('@/views/articulos/List')
const ArticuloABM = () => import('@/views/articulos/ABM')
const ArticuloData = () => import('@/views/articulos/Data')
const ArticulosStock = () => import('@/views/articulos/Stock')
const ArticulosTipos = () => import('@/views/articulosTipos/List')
const ArticuloTipoABM = () => import('@/views/articulosTipos/ABM')
const ArticuloTipoData = () => import('@/views/articulosTipos/Data')
const Bancos = () => import('@/views/bancos/List')
const BancoABM = () => import('@/views/bancos/ABM')
const BancoData = () => import('@/views/bancos/Data')
const BancosCuentas = () => import('@/views/bancoscuentas/List')
const BancoCuentaABM = () => import('@/views/bancoscuentas/ABM')
const BancoCuentaData = () => import('@/views/bancoscuentas/Data')
const BancoCuentaSaldos = () => import('@/views/bancoscuentas/Saldos')
const BancoCuentaCierre = () => import('@/views/bancoscuentas/Cierre')
const BancosChequeras = () => import('@/views/bancoschequeras/List')
const BancoChequeraABM = () => import('@/views/bancoschequeras/ABM')
const BancoChequeraData = () => import('@/views/bancoschequeras/Data')
const BancoChequeraCheques = () => import('@/views/bancoschequeras/Cheques')
const BancosMovimientos = () => import('@/views/bancosmovimientos/List')
const BancoMovimientoABM = () => import('@/views/bancosmovimientos/ABM')
const BancoMovimientoData = () => import('@/views/bancosmovimientos/Data')
const BancosMovimientosTipos = () => import('@/views/bancosmovimientostipos/List')
const BancoMovimientoTipoABM = () => import('@/views/bancosmovimientostipos/ABM')
const BancoMovimientoTipoData = () => import('@/views/bancosmovimientostipos/Data')
const Bienes = () => import('@/views/bienes/List')
const BienAdd = () => import('@/views/bienes/ABM')
const BienEdit = () => import('@/views/bienes/ABM')
const BienData = () => import('@/views/bienes/Data')
const BienesRubros = () => import('@/views/bienesRubros/List')
const BienRubroAdd = () => import('@/views/bienesRubros/ABM')
const BienRubroEdit = () => import('@/views/bienesRubros/ABM')
const BienRubroData = () => import('@/views/bienesRubros/Data')
const Briefs = () => import('@/views/briefs/List')
const BriefAdd = () => import('@/views/briefs/ABM')
const BriefEdit = () => import('@/views/briefs/ABM')
const BriefData = () => import('@/views/briefs/Data')
const BriefAdicionalesAdd = () => import('@/views/briefs/AdicionalAdd')
const BriefCambiosAdd = () => import('@/views/briefs/CambiosAdd')
const BriefsTareasDashboard = () => import('@/views/briefsTareas/DashboardUsuarios')
const BriefsTareas = () => import('@/views/briefsTareas/List')
// const BriefsTareas = () => import('@/views/briefsTareas/Dashboard')
// const BriefsTareas = () => import('@/views/briefsTareas/List')
const BriefsTareasEstados = () => import('@/views/briefsTareasEstados/List')
const BriefTareaEstadoAdd = () => import('@/views/briefsTareasEstados/ABM')
const BriefTareaEstadoEdit = () => import('@/views/briefsTareasEstados/ABM')
const BriefTareaEstadoData = () => import('@/views/briefsTareasEstados/Data')
const Cajas = () => import('@/views/cajas/List')
const CajaABM = () => import('@/views/cajas/ABM')
const CajasRegistros = () => import('@/views/cajasregistros/List')
const CajaRegistroMovimientos = () => import('@/views/cajasregistros/Movimientos')
const Canales = () => import('@/views/canales/List')
const CanalAdd = () => import('@/views/canales/ABM')
const CanalEdit = () => import('@/views/canales/ABM')
const CanalData = () => import('@/views/canales/Data')
const CancelacionesMotivos = () => import('@/views/cancelacionesmotivos/List')
const CancelacionMotivoABM = () => import('@/views/cancelacionesmotivos/ABM')
const CancelacionMotivoData = () => import('@/views/cancelacionesmotivos/Data')
const Cargos = () => import('@/views/cargos/List')
const CargoABM = () => import('@/views/cargos/ABM')
const CargoData = () => import('@/views/cargos/Data')
const CelularAdd = () => import('@/views/bienes/CelularABM')
const CelularEdit = () => import('@/views/bienes/CelularABM')
const CelularData = () => import('@/views/bienes/CelularData')
const CertificadosServicio = () => import('@/views/certificadosServicio/List')
const CertificadoServicioData = () => import('@/views/certificadosServicio/Data')
// const CertificadoServicioABM = () => import('@/views/certificadosServicio/ABM')
const CertificadoServicioAdd = () => import('@/views/certificadosServicio/ABM')
const CertificadoServicioEdit = () => import('@/views/certificadosServicio/ABM')
const ChequesPropios = () => import('@/views/bancosmovimientos/ChequesPropios')
const ChequesTerceros = () => import('@/views/chequesterceros/List')
const ChequeTerceroAdd = () => import('@/views/chequesterceros/ABM')
const ChequeTerceroEdit = () => import('@/views/chequesterceros/ABM')
const ChequeTerceroData = () => import('@/views/chequesterceros/Data')
const Clientes = () => import('@/views/clientes/List')
const ClienteData = () => import('@/views/clientes/Data')
const ClienteABM = () => import('@/views/clientes/ABM')
const ClientesContactos = () => import('@/views/clientescontactos/List')
const ClienteContactoData = () => import('@/views/clientescontactos/Data')
const ClienteContactoABM = () => import('@/views/clientescontactos/ABM')
const ClienteContactoAdministracionData = () => import('@/views/clientescontactosadministracion/Data')
const ClienteContactoAdministracionABM = () => import('@/views/clientescontactosadministracion/ABM')
const ClienteRebate = () => import('@/views/clientesRebates/Rebate')
const ClienteRebateABM = () => import('@/views/clientesRebates/ABM')
const Cobros = () => import('@/views/cobros/List')
const CobroData = () => import('@/views/cobros/Data')
const CobroABM = () => import('@/views/cobros/ABM')
const ComputadoraAdd = () => import('@/views/bienes/ComputadoraABM')
const ComputadoraEdit = () => import('@/views/bienes/ComputadoraABM')
const ComputadoraData = () => import('@/views/bienes/ComputadoraData')
const Compras = () => import('@/views/compras/List')
const CompraData = () => import('@/views/compras/Data')
// const CompraABM = () => import('@/views/compras/ABM')
const CompraAdd = () => import('@/views/compras/ABM')
const CompraOrdenesProveedoresAdd = () => import('@/views/compras/ABM')
const CompraRemitosAdd = () => import('@/views/compras/ABM')
const CompraViaticosAdd = () => import('@/views/compras/ABM')
const CompraCreditoDebito = () => import('@/views/compras/CreditoDebito')
const CompraCreditoParcial = () => import('@/views/compras/CreditoParcial')
const ComprasImpuestos = () => import('@/views/comprasImpuestos/List')
const CompraImpuestoData = () => import('@/views/comprasImpuestos/Data')
const CompraImpuestoABM = () => import('@/views/comprasImpuestos/ABM')
const ControlesStock = () => import('@/views/controlesStock/List')
const ControlStockData = () => import('@/views/controlesStock/Data')
const ControlStockABM = () => import('@/views/controlesStock/ABM')
const CuentaCorrienteClientes = () => import('@/views/cuentacorrienteclientes/List')
const CuentaCorrienteImpuestos = () => import('@/views/cuentacorrienteproveedores/List')
const CuentaCorrienteProveedores = () => import('@/views/cuentacorrienteproveedores/List')
const EncuestasUsuarios = () => import('@/views/encuestasUsuarios/List')
const EncuestaUsuarioCompletar = () => import('@/views/encuestasUsuarios/ABM')
const EncuestaUsuarioData = () => import('@/views/encuestasUsuarios/Data')
const EtiquetasProveedores = () => import('@/views/etiquetasProveedores/List')
const EtiquetaProveedorAdd = () => import('@/views/etiquetasProveedores/ABM')
const EtiquetaProveedorEdit = () => import('@/views/etiquetasProveedores/ABM')
const EtiquetaProveedorData = () => import('@/views/etiquetasProveedores/Data')
const EvaluacionesProveedores = () => import('@/views/evaluacionesProveedores/List')
// const EvaluacionProveedorAdd = () => import('@/views/evaluacionesProveedores/ABM')
const EvaluacionProveedorData = () => import('@/views/evaluacionesProveedores/Data')
const FacturaElectronica = () => import('@/views/parametros/FacturaElectronica')
const FacturasProforma = () => import('@/views/facturasProforma/List')
const FacturaProformaData = () => import('@/views/facturasProforma/Data')
const FacturaProformaABM = () => import('@/views/facturasProforma/ABM')
const FlujoFondos = () => import('@/views/flujoFondos/List')
const FlujoFondosPresupuestos = () => import('@/views/flujoFondosPresupuestos/List')
const FlujoFondosPresupuestoAdd = () => import('@/views/flujoFondosPresupuestos/ABM')
const FormasPago = () => import('@/views/formaspago/List')
const FormaPagoABM = () => import('@/views/formaspago/ABM')
const FormaPagoData = () => import('@/views/formaspago/Data')
const GirosEmpresas = () => import('@/views/girosEmpresas/List')
const GiroEmpresaAdd = () => import('@/views/girosEmpresas/ABM')
const GiroEmpresaEdit = () => import('@/views/girosEmpresas/ABM')
const Impuestos = () => import('@/views/impuestos/List')
const ImpuestoABM = () => import('@/views/impuestos/ABM')
const ImpuestoDatos = () => import('@/views/impuestos/Data')
const ImpuestosOrganismos = () => import('@/views/impuestosOrganismos/List')
const ImpuestoOrganismoABM = () => import('@/views/impuestosOrganismos/ABM')
const ImpuestoOrganismoDatos = () => import('@/views/impuestosOrganismos/Data')
const IndicadoresComprasVentas = () => import('@/views/indicadoresComprasVentas/List')
const IndicadorComprasVentasAdd = () => import('@/views/indicadoresComprasVentas/ABM')
const IndicadorComprasVentasEdit = () => import('@/views/indicadoresComprasVentas/ABM')
const IndicadorComprasVentasData = () => import('@/views/indicadoresComprasVentas/Data')
const IndicadoresGastos = () => import('@/views/indicadoresGastos/List')
const IndicadorGastosAdd = () => import('@/views/indicadoresGastos/ABM')
const IndicadorGastosEdit = () => import('@/views/indicadoresGastos/ABM')
const IndicadorGastosData = () => import('@/views/indicadoresGastos/Data')
const IndicadoresGastosVentas = () => import('@/views/indicadoresGastosVentas/List')
const IndicadorGastosVentasAdd = () => import('@/views/indicadoresGastosVentas/ABM')
const IndicadorGastosVentasEdit = () => import('@/views/indicadoresGastosVentas/ABM')
const IndicadorGastosVentasData = () => import('@/views/indicadoresGastosVentas/Data')
const IndicadoresPlazo = () => import('@/views/indicadoresPlazo/List')
const IndicadorPlazoAdd = () => import('@/views/indicadoresPlazo/ABM')
const IndicadorPlazoEdit = () => import('@/views/indicadoresPlazo/ABM')
const IndicadorPlazoData = () => import('@/views/indicadoresPlazo/Data')
const IndicadoresPlazoProveedoresSemestral = () => import('@/views/indicadoresPlazoProveedores/List')
const IndicadorPlazoProveedoresSemestralAdd = () => import('@/views/indicadoresPlazoProveedores/ABM')
const IndicadorPlazoProveedoresSemestralEdit = () => import('@/views/indicadoresPlazoProveedores/ABM')
const IndicadorPlazoProveedoresSemestralData = () => import('@/views/indicadoresPlazoProveedores/Data')
const IndicadoresPlazoProveedoresAnual = () => import('@/views/indicadoresPlazoProveedores/List')
const IndicadorPlazoProveedoresAnualAdd = () => import('@/views/indicadoresPlazoProveedores/ABM')
const IndicadorPlazoProveedoresAnualEdit = () => import('@/views/indicadoresPlazoProveedores/ABM')
const IndicadorPlazoProveedoresAnualData = () => import('@/views/indicadoresPlazoProveedores/Data')
const IndicadoresPlazoClientes = () => import('@/views/indicadoresPlazoClientes/List')
const IndicadorPlazoClientesAdd = () => import('@/views/indicadoresPlazoClientes/ABM')
const IndicadorPlazoClientesEdit = () => import('@/views/indicadoresPlazoClientes/ABM')
const IndicadorPlazoClientesData = () => import('@/views/indicadoresPlazoClientes/Data')
const IndicadoresRentabilidadAnual = () => import('@/views/indicadoresRentabilidad/List')
const IndicadorRentabilidadAnualAdd = () => import('@/views/indicadoresRentabilidad/ABM')
const IndicadorRentabilidadAnualEdit = () => import('@/views/indicadoresRentabilidad/ABM')
const IndicadorRentabilidadAnualData = () => import('@/views/indicadoresRentabilidad/Data')
const IndicadoresRentabilidadSemestral = () => import('@/views/indicadoresRentabilidad/List')
const IndicadorRentabilidadSemestralAdd = () => import('@/views/indicadoresRentabilidad/ABM')
const IndicadorRentabilidadSemestralEdit = () => import('@/views/indicadoresRentabilidad/ABM')
const IndicadorRentabilidadSemestralData = () => import('@/views/indicadoresRentabilidad/Data')
const IndicadoresRentabilidadNetaAnual = () => import('@/views/indicadoresRentabilidadNeta/List')
const IndicadorRentabilidadNetaAnualAdd = () => import('@/views/indicadoresRentabilidadNeta/ABM')
const IndicadorRentabilidadNetaAnualEdit = () => import('@/views/indicadoresRentabilidadNeta/ABM')
const IndicadorRentabilidadNetaAnualData = () => import('@/views/indicadoresRentabilidadNeta/Data')
const IndicadoresRentabilidadNetaSemestral = () => import('@/views/indicadoresRentabilidadNeta/List')
const IndicadorRentabilidadNetaSemestralAdd = () => import('@/views/indicadoresRentabilidadNeta/ABM')
const IndicadorRentabilidadNetaSemestralEdit = () => import('@/views/indicadoresRentabilidadNeta/ABM')
const IndicadorRentabilidadNetaSemestralData = () => import('@/views/indicadoresRentabilidadNeta/Data')
const IndicadoresRSE = () => import('@/views/indicadoresRSE/List')
const IndicadorRSEAdd = () => import('@/views/indicadoresRSE/ABM')
const IndicadorRSEEdit = () => import('@/views/indicadoresRSE/ABM')
const IndicadorRSEData = () => import('@/views/indicadoresRSE/Data')
const IndicadoresVentas = () => import('@/views/indicadoresVentas/List')
const IndicadorVentasAdd = () => import('@/views/indicadoresVentas/ABM')
const IndicadorVentasEdit = () => import('@/views/indicadoresVentas/ABM')
const IndicadorVentasData = () => import('@/views/indicadoresVentas/Data')
const IndicadoresVentasMixClientesSemestral = () => import('@/views/indicadoresVentasMixClientes/List')
const IndicadorVentasMixClientesSemestralAdd = () => import('@/views/indicadoresVentasMixClientes/ABM')
const IndicadorVentasMixClientesSemestralEdit = () => import('@/views/indicadoresVentasMixClientes/ABM')
const IndicadorVentasMixClientesSemestralData = () => import('@/views/indicadoresVentasMixClientes/Data')
const IndicadoresVentasMixClientesAnual = () => import('@/views/indicadoresVentasMixClientes/List')
const IndicadorVentasMixClientesAnualAdd = () => import('@/views/indicadoresVentasMixClientes/ABM')
const IndicadorVentasMixClientesAnualEdit = () => import('@/views/indicadoresVentasMixClientes/ABM')
const IndicadorVentasMixClientesAnualData = () => import('@/views/indicadoresVentasMixClientes/Data')
const IndicadoresVentasTrimestral = () => import('@/views/indicadoresVentasTrimestral/List')
const IndicadorVentasTrimestralAdd = () => import('@/views/indicadoresVentasTrimestral/ABM')
const IndicadorVentasTrimestralEdit = () => import('@/views/indicadoresVentasTrimestral/ABM')
const IndicadorVentasTrimestralData = () => import('@/views/indicadoresVentasTrimestral/Data')
const IngresosEgresos = () => import('@/views/ingresosegresos/List')
const IngresoEgresoABM = () => import('@/views/ingresosegresos/ABM')
const IngresoEgresoData = () => import('@/views/ingresosegresos/Data')
const InstruccionesCobros = () => import('@/views/instruccionesCobros/List')
const InstruccionCobroABM = () => import('@/views/instruccionesCobros/ABM')
const InstruccionCobroData = () => import('@/views/instruccionesCobros/Data')
const InteresesBancariosRubros = () => import('@/views/interesesBancariosRubros/List')
const InteresBancarioRubroAdd = () => import('@/views/interesesBancariosRubros/ABM')
const InteresBancarioRubroEdit = () => import('@/views/interesesBancariosRubros/ABM')
const InteresBancarioRubroData = () => import('@/views/interesesBancariosRubros/Data')
const LiquidacionesSueldos = () => import('@/views/liquidacionesSueldos/List')
const LiquidacionSueldosAdd = () => import('@/views/liquidacionesSueldos/ABM')
const LiquidacionSueldosEdit = () => import('@/views/liquidacionesSueldos/ABMPersonal')
const LiquidacionSueldosData = () => import('@/views/liquidacionesSueldos/Data')
const LiquidacionSueldosFinalAdd = () => import('@/views/liquidacionesSueldos/LiquidacionFinal')
const LiquidacionSueldosFinalEdit = () => import('@/views/liquidacionesSueldos/LiquidacionFinal')
const LiquidacionSueldosPago = () => import('@/views/liquidacionesSueldos/Pago')
const LiquidacionSueldosPagoDatos = () => import('@/views/liquidacionesSueldos/PagoData')
const Localidades = () => import('@/views/localidades/List')
const LocalidadABM = () => import('@/views/localidades/ABM')
const LocalidadData = () => import('@/views/localidades/Data')
const Marcas = () => import('@/views/marcas/List')
const MarcaAdd = () => import('@/views/marcas/ABM')
const MarcaEdit = () => import('@/views/marcas/ABM')
const MarcaData = () => import('@/views/marcas/Data')
const OrdenesFacturacionLogistica = () => import('@/views/ordenesfacturacionlogistica/List')
const OrdenFacturacionLogisticaData = () => import('@/views/ordenesfacturacionlogistica/Data')
const OrdenFacturacionLogisticaABM = () => import('@/views/ordenesfacturacionlogistica/ABM')
const OrdenesProveedores = () => import('@/views/ordenesproveedores/List')
const OrdenProveedorData = () => import('@/views/ordenesproveedores/Data')
const OrdenProveedorABM = () => import('@/views/ordenesproveedores/ABM')
// const OrdenesTrabajosInternas = () => import('@/views/ordenestrabajosinternas/List')
// const OrdenTrabajoInternaData = () => import('@/views/ordenestrabajosinternas/Data')
const OrdenTrabajoInternaABM = () => import('@/views/ordenesTrabajosInternas/ABM')
const OrdenTrabajoProduccion = () => import('@/views/ordenestrabajos/Produccion')
const Pagos = () => import('@/views/pagos/List')
const PagoData = () => import('@/views/pagos/Data')
const PagoABM = () => import('@/views/pagos/ABM')
const PagosImpuestos = () => import('@/views/pagos/List')
const PagoImpuestosData = () => import('@/views/pagos/Data')
const PagoImpuestosABM = () => import('@/views/pagos/ABM')
const PagoCuotasABM = () => import('@/views/pagos/ABMCuotas')
const Paises = () => import('@/views/paises/List')
const PaisABM = () => import('@/views/paises/ABM')
const Parametros = () => import('@/views/parametros/ABM')
const ParametrosInflacion = () => import('@/views/parametrosinflacion/List')
const ParametroInflacionABM = () => import('@/views/parametrosinflacion/ABM')
const Personal = () => import('@/views/personal/List')
const PersonalAdd = () => import('@/views/personal/ABM')
const PersonalEdit = () => import('@/views/personal/ABM')
const PersonalData = () => import('@/views/personal/Data')
const PersonalNovedades = () => import('@/views/personalNovedades/List')
const PersonalNovedadAdd = () => import('@/views/personalNovedades/ABM')
const PersonalNovedadesCalendario = () => import('@/views/personalNovedades/Calendario')
const PersonalNovedadData = () => import('@/views/personalNovedades/Data')
const PersonalNovedadEdit = () => import('@/views/personalNovedades/ABM')
const PersonalNovedadVacacionesAdd = () => import('@/views/personalNovedades/ABM')
const PersonalNovedadVacacionesEdit = () => import('@/views/personalNovedades/ABM')
const PlanCuentas = () => import('@/views/plancuentas/PlanCuentas')
const PlanesPagos = () => import('@/views/planesPagos/List')
const PlanPagosABM = () => import('@/views/planesPagos/ABM')
const PlanPagosData = () => import('@/views/planesPagos/Data')
const PresupuestosGastosConceptos = () => import('@/views/presupuestosGastosConceptos/List')
const PresupuestoGastosConceptoAdd = () => import('@/views/presupuestosGastosConceptos/ABM')
const PresupuestoGastosConceptoEdit = () => import('@/views/presupuestosGastosConceptos/ABM')
const PresupuestoGastosConceptoData = () => import('@/views/presupuestosGastosConceptos/Data')
const PresupuestosGastos = () => import('@/views/presupuestosGastos/List')
const PresupuestosGastosComparativo = () => import('@/views/presupuestosGastos/Comparativo')
const PresupuestoGastosAdd = () => import('@/views/presupuestosGastos/ABM')
const PresupuestoGastosEdit = () => import('@/views/presupuestosGastos/ABM')
const PresupuestoGastosDuplicar = () => import('@/views/presupuestosGastos/ABM')
const PresupuestoGastosData = () => import('@/views/presupuestosGastos/Data')
const PresupuestosInternos = () => import('@/views/presupuestosinternos/List')
const PresupuestosInternosCancelados = () => import('@/views/presupuestosinternos/ListCancelados')
const PresupuestoInternoData = () => import('@/views/presupuestosinternos/Data')
const PresupuestoInternoDataConsolidado = () => import('@/views/presupuestosinternos/Data')
const PresupuestoInternoABM = () => import('@/views/presupuestosinternos/ABM')
const PresupuestoInternoAdicional = () => import('@/views/presupuestosinternos/ABM')
const PresupuestoInternoProduccion = () => import('@/views/presupuestosinternos/Produccion')
const PresupuestoInternoUsuariosSeleccion = () => import('@/views/presupuestosinternos/UsuariosSeleccion')
const Proveedores = () => import('@/views/proveedores/List')
const ProveedorData = () => import('@/views/proveedores/Data')
const ProveedorAdd = () => import('@/views/proveedores/ABM')
const ProveedorEdit = () => import('@/views/proveedores/ABM')
const Provincias = () => import('@/views/provincias/List')
const ProvinciaData = () => import('@/views/provincias/Data')
const ProvinciaABM = () => import('@/views/provincias/ABM')
const Remitos = () => import('@/views/remitos/List')
const RemitoData = () => import('@/views/remitos/Data')
const RemitoAlta = () => import('@/views/remitos/ABM')
const RemitoDuplicado = () => import('@/views/remitos/ABM')
const RemitoDuplicadoCancelado = () => import('@/views/remitos/ABM')
// const RemitosInternos = () => import('@/views/remitos/List')
// const RemitoInternoData = () => import('@/views/remitos/Data')
const RemitoInternoAlta = () => import('@/views/remitos/ABM')
const RemitoInternoDuplicado = () => import('@/views/remitos/ABM')
const RemitoInternoDuplicadoCancelado = () => import('@/views/remitos/ABM')
const RemitosActualizacionImportes = () => import('@/views/remitos/ActualizacionImportes')
const RemitosDestinos = () => import('@/views/remitosdestinos/List')
const RemitoDestinoData = () => import('@/views/remitosdestinos/Data')
const RemitoDestinoABM = () => import('@/views/remitosdestinos/ABM')
const ResumenComisionesVendedor = () => import('@/views/vendedores/Resumen')
const ResumenComisionesCobrosVendedor = () => import('@/views/vendedores/ResumenCobros')
const ResumenGastos = () => import('@/views/resumenGastos/ResumenGastos')
const RetencionesClientes = () => import('@/views/retencionesclientes/List')
const RetencionClienteData = () => import('@/views/retencionesclientes/Data')
const RetencionesTipos = () => import('@/views/retencionestipos/List')
const RetencionTipoABM = () => import('@/views/retencionestipos/ABM')
const RetencionTipoData = () => import('@/views/retencionestipos/Data')
const RetencionesRegimenes = () => import('@/views/retencionesregimenes/List')
const RetencionRegimenABM = () => import('@/views/retencionesregimenes/ABM')
const RetencionRegimenData = () => import('@/views/retencionesregimenes/Data')
const RptCobros = () => import('@/views/cobros/Rpt')
// const RptCompras = () => import('@/views/compras/Rpt')
const RptComprasFecha = () => import('@/views/compras/RptFecha')
const RptComprasGastos = () => import('@/views/compras/RptComprasGastos')
const RptClientesContactos = () => import('@/views/clientescontactos/Rpt')
const RptDeudaClientes = () => import('@/views/cuentacorrienteclientes/RptDeuda')
const RptDeudaProveedores = () => import('@/views/cuentacorrienteproveedores/RptDeuda')
const RptEncuestasUsuarios = () => import('@/views/encuestasUsuarios/Rpt')
const RptEvolucionSueldos = () => import('@/views/liquidacionesSueldos/RptEvolucionSueldos')
const RptHolistorVentas = () => import('@/views/holistor/RptVentas')
const RptIngresosGastos = () => import('@/views/bancosmovimientos/RptIngresosGastos')
const RptOrdenesProveedoresPendientes = () => import('@/views/ordenesproveedores/RptPendientes')
const RptOrdenesNegativas = () => import('@/views/ordenestrabajos/RptOrdenesNegativas')
const RptOrdenesRemitos = () => import('@/views/compras/RptOrdenesRemitos')
const RptPagos = () => import('@/views/pagos/Rpt')
const RptPercepcionesCompras = () => import('@/views/compras/RptPercepciones')
const RptPlazosClientes = () => import('@/views/cuentacorrienteclientes/RptPlazos')
const RptPlazosProveedores = () => import('@/views/cuentacorrienteproveedores/RptPlazos')
const RptPresupuestosInternos = () => import('@/views/presupuestosinternos/Rpt')
const RptPresupuestosInternosAperturasCierres = () => import('@/views/presupuestosinternos/RptAperturasCierres')
const RptPresupuestosInternosCancelados = () => import('@/views/presupuestosinternos/RptCancelados')
const RptPresupuestosInternosCerrados = () => import('@/views/presupuestosinternos/RptCerrados')
const RptPresupuestosInternosPremios = () => import('@/views/presupuestosinternos/RptPremios')
const RptResumenRemitos = () => import('@/views/remitos/Rpt')
const RptRetencionesClientes = () => import('@/views/retencionesclientes/Rpt')
const RptVendedoresComisiones = () => import('@/views/vendedores/RptComisiones')
const RptVendedoresComisionesInternas = () => import('@/views/vendedores/RptComisiones')
const RptVentas = () => import('@/views/ventas/Rpt')
const RptVentasComparativo = () => import('@/views/ventas/RptComparativo')
const RptVentasResumenClientes = () => import('@/views/ventas/RptResumenClientes')
const RubrosTrabajos = () => import('@/views/rubrostrabajos/List')
const RubroTrabajosABM = () => import('@/views/rubrostrabajos/ABM')
const RubroTrabajosData = () => import('@/views/rubrostrabajos/Data')
const ViaticosRubros = () => import('@/views/viaticosRubros/List')
const ViaticoRubroAdd = () => import('@/views/viaticosRubros/ABM')
const ViaticoRubroEdit = () => import('@/views/viaticosRubros/ABM')
const ViaticoRubroData = () => import('@/views/viaticosRubros/Data')
const Subtrabajos = () => import('@/views/ordenesSubtrabajos/List')
const Tarjetas = () => import('@/views/tarjetas/List')
const TarjetaAdd = () => import('@/views/tarjetas/ABM')
const TarjetaEdit = () => import('@/views/tarjetas/ABM')
const TarjetaData = () => import('@/views/tarjetas/Data')
const TarjetasPlasticos = () => import('@/views/tarjetasPlasticos/List')
const TarjetaPlasticoAdd = () => import('@/views/tarjetasPlasticos/ABM')
const TarjetaPlasticoEdit = () => import('@/views/tarjetasPlasticos/ABM')
const TarjetaPlasticoData = () => import('@/views/tarjetasPlasticos/Data')
const TarjetasCupones = () => import('@/views/tarjetascupones/List')
const TarjetaCuponABM = () => import('@/views/tarjetascupones/ABM')
const TarjetaCuponData = () => import('@/views/tarjetascupones/Data')
const TarjetasMarcas = () => import('@/views/tarjetasmarcas/List')
const TarjetaMarcaABM = () => import('@/views/tarjetasmarcas/ABM')
const TarjetaMarcaData = () => import('@/views/tarjetasmarcas/Data')
const TarjetasVencimientos = () => import('@/views/tarjetasResumenes/List')
const TarjetaVencimientoAdd = () => import('@/views/tarjetasResumenes/ABM')
const TarjetaVencimientoData = () => import('@/views/tarjetasResumenes/Data')
const TarjetasResumenes = () => import('@/views/tarjetasResumenes/Vencimientos')
const TarjetasResumenesNoResumen = () => import('@/views/tarjetasResumenes/Vencimientos')
const TarjetaResumenData = () => import('@/views/tarjetasResumenes/Vencimiento')
const TarjetaResumenDataNoResumen = () => import('@/views/tarjetasResumenes/Vencimiento')
const TarjetaResumenPagos = () => import('@/views/tarjetasResumenesPagos/List')
const TarjetaResumenPago = () => import('@/views/tarjetasResumenesPagos/ABM')
const TarjetaResumenPagoData = () => import('@/views/tarjetasResumenesPagos/Data')
const TiposDisenios = () => import('@/views/tiposDisenios/List')
const TipoDisenioAdd = () => import('@/views/tiposDisenios/ABM')
const TipoDisenioEdit = () => import('@/views/tiposDisenios/ABM')
const TipoDisenioData = () => import('@/views/tiposDisenios/Data')
const TiposNovedades = () => import('@/views/tiposNovedades/List')
const TipoNovedadABM = () => import('@/views/tiposNovedades/ABM')
const TipoNovedadData = () => import('@/views/tiposNovedades/Data')
const TiposPresupuestos = () => import('@/views/tiposPresupuestos/List')
const TipoPresupuestoAdd = () => import('@/views/tiposPresupuestos/ABM')
const TipoPresupuestoEdit = () => import('@/views/tiposPresupuestos/ABM')
const TipoPresupuestoData = () => import('@/views/tiposPresupuestos/Data')
const TransferenciaPremiosAsignacion = () => import('@/views/bancosmovimientos/TransferenciaPremiosAsignacion')
const TransferenciasPremios = () => import('@/views/bancosmovimientos/TransferenciasPremios')
const TransferenciasPremiosImputaciones = () => import('@/views/bancosmovimientos/TransferenciasPremiosImputaciones')
const TransferenciasPremiosImputacionABM = () => import('@/views/bancosmovimientos/TransferenciasPremiosImputacionABM')
const Usuarios = () => import('@/views/usuarios/List')
// const UsuarioABM = () => import('@/views/usuarios/ABM')
const UsuarioAdd = () => import('@/views/usuarios/ABM')
const UsuarioEdit = () => import('@/views/usuarios/ABM')
const UsuarioData = () => import('@/views/usuarios/Data')
const UsuarioPerfil = () => import('@/views/usuarios/Perfil')
const UsuarioPass = () => import('@/views/usuarios/Pass')
const UsuarioSelfPass = () => import('@/views/usuarios/Pass')
const Vendedores = () => import('@/views/vendedores/List')
const VendedorAdd = () => import('@/views/vendedores/ABM')
const VendedorEdit = () => import('@/views/vendedores/ABM')
const VendedorData = () => import('@/views/vendedores/Data')
const VendedorCuentaCorriente = () => import('@/views/vendedores/CuentaCorriente')
const VendedorCuentaCorrienteCobros = () => import('@/views/vendedores/CuentaCorriente')
const Ventas = () => import('@/views/ventas/List')
const VentaData = () => import('@/views/ventas/Data')
const VentaABM = () => import('@/views/ventas/ABM')
const VentaABMExportacion = () => import('@/views/ventas/ABM')
const VentaABMCertificados = () => import('@/views/ventas/ABMCertificados')
const VentaABMCertificadosExportacion = () => import('@/views/ventas/ABMCertificados')
const VentaABMCreditoDebito = () => import('@/views/ventas/ABMCreditosDebitos')
const VentaABMCreditoFee = () => import('@/views/ventas/ABMCredito')
const VentaABMCreditoFinanciacion = () => import('@/views/ventas/ABMCredito')
const VentaABMCreditoFinanciacionComprobantes = () => import('@/views/ventas/ABMCreditoFinanciacion')
const VentasNegociaciones = () => import('@/views/ventas/Negociaciones')
const VentaNegociacionData = () => import('@/views/ventas/Data')
const VentaNegociacion = () => import('@/views/ventas/Negociacion')
const Viaticos = () => import('@/views/viaticos/List')
const ViaticoAdd = () => import('@/views/viaticos/ABM')
const ViaticoData = () => import('@/views/viaticos/Data')
const ViaticoEdit = () => import('@/views/viaticos/ABM')
const ViaticoPago = () => import('@/views/viaticos/Pago')
const ViaticoDevolucion = () => import('@/views/viaticos/Pago')
const ViaticoRendicion = () => import('@/views/viaticos/Rendicion')

const Empresa = () => import('@/views/empresas/ABM')

Vue.use(Router)

function requireAuth(to, from, next) {
  if (!store.getters['user/loggedIn']) {
    store
      .dispatch('user/tryLogin')
      .then(() => {
        /* Logueamos a partir de las credenciales del localStorage */
        next()
      })
      .catch(() => {
        /* No hay un usuario logueado, redirigimos al login */
        next('/pages/login')
      })
  } else {
    if (!store.getters['user/tieneAcceso'](to)) {
      next('/')
    } else {
      /* Acceso habilitado */
      next()
    }
  }
}

function isRecoverableAsyncComponentError(error) {
  if (!error) {
    return false
  }

  const message = error.message || String(error)
  return /Loading chunk [\d]+ failed|Loading CSS chunk [\d]+ failed|ChunkLoadError|modules\[moduleId\] is undefined|Failed to fetch dynamically imported module|Importing a module script failed|Cannot find module|Unexpected token '</i.test(message)
}

function forceReloadBypassingCache() {
  const recoverParamKey = 'sgc_router_recover'
  const basePath = window.location.origin + window.location.pathname
  const hash = window.location.hash || ''
  const reloadUrl = basePath + '?' + recoverParamKey + '=' + Date.now() + hash

  window.location.replace(reloadUrl)
}

function clearRecoverQueryParam() {
  const recoverParamKey = 'sgc_router_recover'
  const search = window.location.search || ''
  if (search.indexOf(recoverParamKey + '=') === -1) {
    return
  }

  const basePath = window.location.origin + window.location.pathname
  const hash = window.location.hash || ''
  const queryItems = search
    .replace(/^\?/, '')
    .split('&')
    .filter((item) => item && item.indexOf(recoverParamKey + '=') !== 0)
  const queryString = queryItems.length ? '?' + queryItems.join('&') : ''

  window.history.replaceState(window.history.state, '', basePath + queryString + hash)
}

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      meta: { label: 'Inicio' },
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'CervettiDashboard',
          meta: { label: 'Tablero de Control' },
          component: CervettiDashboard,
          beforeEnter: requireAuth,
        },

        /* VENTAS */
        {
          path: 'ventas',
          meta: { label: 'Ventas' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          children: [
            {
              path: 'presupuestosinternos',
              meta: { label: 'Presupuestos Internos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  name: 'PresupuestosInternos',
                  meta: { label: 'Listado de Presupuestos Internos' },
                  component: PresupuestosInternos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Presupuesto' },
                  name: 'PresupuestoInternoABM',
                  component: PresupuestoInternoABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':presupuestoInicialId/adicional',
                  meta: { label: 'Información del Presupuesto' },
                  name: 'PresupuestoInternoAdicional',
                  component: PresupuestoInternoAdicional,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/produccion',
                  meta: { label: 'Información de Producción' },
                  name: 'PresupuestoInternoProduccion',
                  component: PresupuestoInternoProduccion,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/usuarios',
                  meta: { label: 'Usuarios del Presupuesto' },
                  name: 'PresupuestoInternoUsuariosSeleccion',
                  component: PresupuestoInternoUsuariosSeleccion,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/consolidado',
                  meta: { label: 'Informacion del Presupuesto' },
                  name: 'PresupuestoInternoDataConsolidado',
                  component: PresupuestoInternoDataConsolidado,
                  beforeEnter: requireAuth,
                  props: { incluirAdicionales: true },
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Presupuesto' },
                  name: 'PresupuestoInternoData',
                  component: PresupuestoInternoData,
                  beforeEnter: requireAuth,
                  props: { incluirAdicionales: false },
                },
                {
                  path: 'ordenestrabajo',
                  meta: { label: 'Ordenes de Trabajo' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: ':id/produccion',
                      name: 'OrdenTrabajoProduccion',
                      meta: { label: 'Información de Producción' },
                      component: OrdenTrabajoProduccion,
                      // props: true
                    },
                  ],
                },
              ],
            },
            {
              path: 'presupuestos-cancelados',
              meta: { label: 'Presupuestos Cancelados' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  name: 'PresupuestosInternosCancelados',
                  meta: { label: 'Listado de Presupuestos Cancelados' },
                  component: PresupuestosInternosCancelados,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'facturas-proforma',
              meta: { label: 'Facturas Proforma' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'FacturasProforma',
                  meta: { label: 'Listado de Facturas Proforma' },
                  component: FacturasProforma,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ABM',
                  meta: { label: 'Factura Proforma' },
                  name: 'FacturaProformaABM',
                  component: FacturaProformaABM,
                  beforeEnter: requireAuth,
                  props: true,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Factura' },
                  name: 'FacturaProformaData',
                  component: FacturaProformaData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'certificados-servicio',
              meta: { label: 'Certificados de Servicio' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'CertificadosServicio',
                  meta: { label: 'Listado de Certificados de Servicio' },
                  component: CertificadosServicio,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'presupuesto/:presupuestoId/add',
                  meta: { label: 'Certificado de Servicio' },
                  name: 'CertificadoServicioAdd',
                  component: CertificadoServicioAdd,
                  beforeEnter: requireAuth,
                  props: true,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Certificado' },
                  name: 'CertificadoServicioEdit',
                  component: CertificadoServicioEdit,
                  beforeEnter: requireAuth,
                },
                // {
                //   path: 'ABM',
                //   meta: { label: 'Certificado de Servicio'},
                //   name: 'CertificadoServicioABM',
                //   component: CertificadoServicioABM,
                //   beforeEnter: requireAuth,
                //   props: true
                // },
                {
                  path: ':id',
                  meta: { label: 'Información del Certificado' },
                  name: 'CertificadoServicioData',
                  component: CertificadoServicioData,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'facturas',
              meta: { label: 'Facturas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'Facturas',
                  meta: { label: 'Listado de Comprobantes' },
                  component: Ventas,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ABM',
                  meta: { label: 'Informacion del Comprobante' },
                  name: 'VentaABM',
                  component: VentaABM,
                  beforeEnter: requireAuth,
                  props: { facturaExportacion: false },
                },
                {
                  path: 'ABME',
                  meta: { label: 'Informacion del Comprobante' },
                  name: 'VentaABMExportacion',
                  component: VentaABMExportacion,
                  beforeEnter: requireAuth,
                  props: { facturaExportacion: true },
                },
                {
                  path: 'ABMC',
                  meta: { label: 'Informacion del Comprobante' },
                  name: 'VentaABMCertificados',
                  component: VentaABMCertificados,
                  beforeEnter: requireAuth,
                  props: { facturaExportacion: false },
                },
                {
                  path: 'ABMCE',
                  meta: { label: 'Informacion del Comprobante' },
                  name: 'VentaABMCertificadosExportacion',
                  component: VentaABMCertificadosExportacion,
                  beforeEnter: requireAuth,
                  props: { facturaExportacion: true },
                },
                {
                  path: 'credito-financiacion',
                  meta: { label: 'Credito Financiacion' },
                  name: 'VentaABMCreditoFinanciacionComprobantes',
                  component: VentaABMCreditoFinanciacionComprobantes,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Comprobante' },
                  name: 'VentaData',
                  component: VentaData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/credito-debito',
                  meta: { label: 'Credito/Debito' },
                  name: 'VentaABMCreditoDebito',
                  component: VentaABMCreditoDebito,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/credito-financiacion',
                  meta: { label: 'Credito Financiacion' },
                  name: 'VentaABMCreditoFinanciacion',
                  component: VentaABMCreditoFinanciacion,
                  beforeEnter: requireAuth,
                  props: { creditoFinanciacion: true },
                },
                {
                  path: ':id/credito-fee',
                  meta: { label: 'Credito Fee' },
                  name: 'VentaABMCreditoFee',
                  component: VentaABMCreditoFee,
                  beforeEnter: requireAuth,
                  props: { creditoFinanciacion: false },
                },
                {
                  path: ':id/negociacion',
                  meta: { label: 'Negociacion del Comprobante' },
                  name: 'VentaNegociacion',
                  component: VentaNegociacion,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'subtrabajos',
              meta: { label: 'Subtrabajos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  name: 'Subtrabajos',
                  // meta: { label: 'Listado de Subtrabajos'},
                  meta: { label: 'Buscador de Ordenes a Proveedores' },
                  component: Subtrabajos,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'facturas-negociadas',
              meta: { label: 'Facturas Negociadas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'VentasNegociaciones',
                  meta: { label: 'Listado de Facturas Negociadas' },
                  component: VentasNegociaciones,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Comprobante' },
                  name: 'VentaNegociacionData',
                  component: VentaNegociacionData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        /* Diseño */
        {
          path: 'disenio',
          meta: { label: 'Diseño' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          children: [
            {
              path: 'dashboard',
              meta: { label: 'Dashboard' },
              name: 'BriefsTareasDashboard',
              component: BriefsTareasDashboard,
              beforeEnter: requireAuth,
            },
            {
              path: 'tareas',
              meta: { label: 'Listado de Tareas' },
              name: 'BriefsTareas',
              component: BriefsTareas,
              beforeEnter: requireAuth,
            },
            {
              path: 'briefs',
              meta: { label: 'Briefs' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  name: 'Briefs',
                  meta: { label: 'Listado de Briefs' },
                  component: Briefs,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Informacion del Brief' },
                  name: 'BriefAdd',
                  component: BriefAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Informacion del Brief' },
                  name: 'BriefEdit',
                  component: BriefEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/adicionales',
                  meta: { label: 'Solicitud de Adicionales' },
                  name: 'BriefAdicionalesAdd',
                  component: BriefAdicionalesAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/cambios',
                  meta: { label: 'Solicitud de Cambios' },
                  name: 'BriefCambiosAdd',
                  component: BriefCambiosAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Brief' },
                  name: 'BriefData',
                  component: BriefData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        {
          path: 'logistica/remitos',
          meta: { label: 'Logística' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'Remitos',
              meta: { label: 'Listado de Remitos' },
              component: Remitos,
              beforeEnter: requireAuth,
              props: { remitoInterno: false },
            },
            {
              path: 'add',
              meta: { label: 'Informacion del Remito' },
              name: 'RemitoAlta',
              component: RemitoAlta,
              beforeEnter: requireAuth,
              props: { remitoInterno: false },
            },
            {
              path: 'add',
              meta: { label: 'Informacion del Remito Interno' },
              name: 'RemitoInternoAlta',
              component: RemitoInternoAlta,
              beforeEnter: requireAuth,
              props: { remitoInterno: true },
            },
            {
              path: ':id/duplicado',
              meta: { label: 'Información del Remito' },
              name: 'RemitoDuplicado',
              component: RemitoDuplicado,
              beforeEnter: requireAuth,
              props: { remitoInterno: false, cancelarRemito: false },
            },
            {
              path: ':id/duplicado',
              meta: { label: 'Información del Remito' },
              name: 'RemitoDuplicadoCancelado',
              component: RemitoDuplicadoCancelado,
              beforeEnter: requireAuth,
              props: { remitoInterno: false, cancelarRemito: true },
            },
            {
              path: ':id/duplicado',
              meta: { label: 'Información del Remito Interno' },
              name: 'RemitoInternoDuplicado',
              component: RemitoInternoDuplicado,
              beforeEnter: requireAuth,
              props: { remitoInterno: true, cancelarRemito: false },
            },
            {
              path: ':id/duplicado',
              meta: { label: 'Información del Remito Interno' },
              name: 'RemitoInternoDuplicadoCancelado',
              component: RemitoInternoDuplicadoCancelado,
              beforeEnter: requireAuth,
              props: { remitoInterno: true, cancelarRemito: true },
            },
            {
              path: ':id',
              meta: { label: 'Informacion del Remito' },
              name: 'RemitoData',
              component: RemitoData,
              beforeEnter: requireAuth,
              props: { remitoInterno: false },
            },
          ],
        },
        {
          path: 'logistica/actualizacion-importes',
          meta: { label: 'Logística' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              meta: { label: 'Actualización de Remitos' },
              name: 'RemitosActualizacionImportes',
              component: RemitosActualizacionImportes,
              beforeEnter: requireAuth,
            },
          ],
        },

        {
          path: 'logistica/ordenesfacturacion',
          meta: { label: 'Logística' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'OrdenesFacturacionLogistica',
              meta: { label: 'Listado de Ordenes de Facturacion' },
              component: OrdenesFacturacionLogistica,
              beforeEnter: requireAuth,
            },
            {
              path: ':id',
              meta: { label: 'Informacion de la Orden' },
              name: 'OrdenFacturacionLogisticaData',
              component: OrdenFacturacionLogisticaData,
              beforeEnter: requireAuth,
            },
            {
              path: ':id/ABM',
              meta: { label: 'Información de la Orden' },
              name: 'OrdenFacturacionLogisticaABM',
              component: OrdenFacturacionLogisticaABM,
              beforeEnter: requireAuth,
            },
          ],
        },

        /* Clientes */
        {
          path: 'clientes',
          meta: { label: 'Clientes' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'clientes',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Clientes' },
                  name: 'Clientes',
                  component: Clientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Cliente' },
                  name: 'ClienteABM',
                  component: ClienteABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Cliente' },
                  name: 'ClienteDatos',
                  component: ClienteData,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'contactos',
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: ':clienteId',
                      meta: { label: 'Contactos de Clientes' },
                      name: 'ClientesContactos',
                      component: ClientesContactos,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':clienteId/:id/ABM',
                      meta: { label: 'Información del Contacto' },
                      name: 'ClienteContactoABM',
                      component: ClienteContactoABM,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':clienteId/:id',
                      meta: { label: 'Información del Contacto' },
                      name: 'ClienteContactoData',
                      component: ClienteContactoData,
                      beforeEnter: requireAuth,
                    },
                  ],
                },
                {
                  path: 'contactosadministracion',
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: ':clienteId/:id/ABM',
                      meta: { label: 'Información del Contacto de Administración' },
                      name: 'ClienteContactoAdministracionABM',
                      component: ClienteContactoAdministracionABM,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':clienteId/:id',
                      meta: { label: 'Información del Contacto de Administración' },
                      name: 'ClienteContactoAdministracionData',
                      component: ClienteContactoAdministracionData,
                      beforeEnter: requireAuth,
                    },
                  ],
                },
              ],
            },
            {
              path: 'cobros',
              meta: { label: 'Ordenes de Cobro' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'Cobros',
                  meta: { label: 'Listado de Ordenes de Cobro' },
                  component: Cobros,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ABM',
                  meta: { label: 'Información de la Orden de Cobro' },
                  name: 'CobroABM',
                  component: CobroABM,
                  beforeEnter: requireAuth,
                  props: true,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Orden de Cobro' },
                  name: 'CobroData',
                  component: CobroData,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'instrucciones-cobros',
              meta: { label: 'Instrucciones de Cobro' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'InstruccionesCobros',
                  meta: { label: 'Listado de Instrucciones de Cobro' },
                  component: InstruccionesCobros,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información de la Instrucción de Cobro' },
                  name: 'InstruccionCobroABM',
                  component: InstruccionCobroABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Instrucción de Cobro' },
                  name: 'InstruccionCobroData',
                  component: InstruccionCobroData,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'cuentacorriente',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'CuentaCorrienteClientes',
                  meta: { label: 'Cuenta Corriente de Clientes' },
                  component: CuentaCorrienteClientes,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'rebate',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'ClienteRebate',
                  meta: { label: 'Rebate' },
                  component: ClienteRebate,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ABM',
                  name: 'ClienteRebateABM',
                  meta: { label: 'Rebate' },
                  component: ClienteRebateABM,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'retenciones-clientes',
              meta: { label: 'Retenciones de Clientes' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Retenciones de Clientes' },
                  name: 'RetencionesClientes',
                  component: RetencionesClientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Datos de la Retención' },
                  name: 'RetencionClienteData',
                  component: RetencionClienteData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        {
          path: 'logistica/destinos',
          meta: { label: 'Logística' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              meta: { label: 'Listado de Destinos de Envío' },
              name: 'RemitosDestinos',
              component: RemitosDestinos,
              beforeEnter: requireAuth,
            },
            {
              path: ':id/ABM',
              meta: { label: 'Información del Destino' },
              name: 'RemitoDestinoABM',
              component: RemitoDestinoABM,
              beforeEnter: requireAuth,
            },
            {
              path: ':id',
              meta: { label: 'Información del Destino' },
              name: 'RemitoDestinoData',
              component: RemitoDestinoData,
              beforeEnter: requireAuth,
            },
          ],
        },

        /* COMPRAS */
        {
          path: 'compras',
          meta: { label: 'Compras' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'compras',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'Compras',
                  meta: { label: 'Listado de Compras' },
                  component: Compras,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Comprobante' },
                  name: 'CompraAdd',
                  component: CompraAdd,
                  beforeEnter: requireAuth,
                  props: { routedFrom: 'Compras' },
                },
                {
                  path: 'ordenes-proveedores/add',
                  meta: { label: 'Información del Comprobante' },
                  name: 'CompraOrdenesProveedoresAdd',
                  component: CompraOrdenesProveedoresAdd,
                  beforeEnter: requireAuth,
                  props: {
                    routedFrom: 'Compras',
                    ordenesProveedor: true,
                  },
                },
                {
                  path: 'remitos/add',
                  meta: { label: 'Información del Comprobante' },
                  name: 'CompraRemitosAdd',
                  component: CompraRemitosAdd,
                  beforeEnter: requireAuth,
                  props: {
                    routedFrom: 'Compras',
                    remitos: true,
                  },
                },
                {
                  path: 'viaticos/:viaticoId/add',
                  meta: { label: 'Información del Comprobante' },
                  name: 'CompraViaticosAdd',
                  component: CompraViaticosAdd,
                  beforeEnter: requireAuth,
                  props: { routedFrom: 'Compras' },
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Comprobante' },
                  name: 'CompraData',
                  component: CompraData,
                  beforeEnter: requireAuth,
                  props: { routedFrom: 'Compras' },
                },
                // {
                //   path: ':id/ABM',
                //   meta: { label: 'Información del Comprobante'},
                //   name: 'CompraABM',
                //   component: CompraABM,
                //   beforeEnter: requireAuth,
                //   props: true
                // },
                {
                  path: ':id/credito-debito',
                  meta: { label: 'Crédito/Débito' },
                  name: 'CompraCreditoDebito',
                  component: CompraCreditoDebito,
                  beforeEnter: requireAuth,
                  props: true,
                },
                {
                  path: ':id/credito',
                  meta: { label: 'Crédito' },
                  name: 'CompraCreditoParcial',
                  component: CompraCreditoParcial,
                  beforeEnter: requireAuth,
                  props: true,
                },
              ],
            },
          ],
        },

        /* STOCK */
        {
          path: 'stock',
          meta: { label: 'Stock' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            // {
            //   path: 'ordenestrabajosinternas',
            //   component: {
            //     render (c) { return c('router-view') }
            //   },
            //   beforeEnter: requireAuth,
            //   children: [
            //     {
            //       path: '',
            //       meta: { label: 'Listado de Ordenes de Trabajo Internas'},
            //       name: 'OrdenesTrabajosInternas',
            //       component: OrdenesTrabajosInternas,
            //     },
            //     {
            //       path: ':id/ABM',
            //       meta: { label: 'Información de la Orden'},
            //       name: 'OrdenTrabajoInternaABM',
            //       component: OrdenTrabajoInternaABM,
            //     },
            //     {
            //       path: ':id',
            //       meta: { label: 'Información de la Orden'},
            //       name: 'OrdenTrabajoInternaDatos',
            //       component: OrdenTrabajoInternaData,
            //     },
            //   ]
            // },
            {
              path: 'articulos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Stock' },
                  name: 'ArticulosStock',
                  component: ArticulosStock,
                },
              ],
            },
            {
              path: 'controles-stock',
              meta: { label: 'Controles de Stock' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'ControlesStock',
                  meta: { label: 'Listado de Controles de Stock' },
                  component: ControlesStock,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Informacion del Control de Stock' },
                  name: 'ControlStockABM',
                  component: ControlStockABM,
                  beforeEnter: requireAuth,
                  props: { facturaExportacion: false },
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Control de Stock' },
                  name: 'ControlStockData',
                  component: ControlStockData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        /* RRHH */
        {
          path: 'rrhh',
          meta: { label: 'RRHH' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'personal',
              meta: { label: 'Personal' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Personal' },
                  name: 'Personal',
                  component: Personal,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Personal' },
                  name: 'PersonalAdd',
                  component: PersonalAdd,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Personal' },
                  name: 'PersonalEdit',
                  component: PersonalEdit,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Personal' },
                  name: 'PersonalDatos',
                  component: PersonalData,
                },
              ],
            },
            {
              path: 'ingresos-egresos',
              meta: { label: 'Ingresos/Egresos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Ingresos/Egresos' },
                  name: 'IngresosEgresos',
                  component: IngresosEgresos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Movimiento' },
                  name: 'IngresoEgresoABM',
                  component: IngresoEgresoABM,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Movimiento' },
                  name: 'IngresoEgresoData',
                  component: IngresoEgresoData,
                },
              ],
            },
            {
              path: 'liquidaciones-sueldos',
              meta: { label: 'Liquidaciones de Sueldo' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Liquidaciones' },
                  name: 'LiquidacionesSueldos',
                  component: LiquidacionesSueldos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información de la Liquidación' },
                  name: 'LiquidacionSueldosAdd',
                  component: LiquidacionSueldosAdd,
                },
                {
                  path: 'liquidacion-final/add',
                  meta: { label: 'Liquidación Final' },
                  name: 'LiquidacionSueldosFinalAdd',
                  component: LiquidacionSueldosFinalAdd,
                },
                {
                  path: 'liquidacion-final/:id/edit',
                  meta: { label: 'Liquidación Final' },
                  name: 'LiquidacionSueldosFinalEdit',
                  component: LiquidacionSueldosFinalEdit,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Liquidación' },
                  name: 'LiquidacionSueldosData',
                  component: LiquidacionSueldosData,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información de la Liquidación' },
                  name: 'LiquidacionSueldosEdit',
                  component: LiquidacionSueldosEdit,
                },
                {
                  path: ':liquidacionSueldosId/pago',
                  meta: { label: 'Pago de Honorarios' },
                  name: 'LiquidacionSueldosPago',
                  component: LiquidacionSueldosPago,
                },
                {
                  path: ':liquidacionSueldosId/pago/:id',
                  meta: { label: 'Información del Pago' },
                  name: 'LiquidacionSueldosPagoDatos',
                  component: LiquidacionSueldosPagoDatos,
                },
              ],
            },
            {
              path: 'novedades',
              meta: { label: 'Novedades del Personal' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Novedades' },
                  name: 'PersonalNovedades',
                  component: PersonalNovedades,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información de la Novedad' },
                  name: 'PersonalNovedadAdd',
                  component: PersonalNovedadAdd,
                  props: { vacaciones: false },
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Novedad' },
                  name: 'PersonalNovedadData',
                  component: PersonalNovedadData,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información de la Novedad' },
                  name: 'PersonalNovedadEdit',
                  component: PersonalNovedadEdit,
                },
                {
                  path: 'vacaciones/add',
                  meta: { label: 'Información de las Vacaciones' },
                  name: 'PersonalNovedadVacacionesAdd',
                  component: PersonalNovedadVacacionesAdd,
                  props: { vacaciones: true },
                },
                {
                  path: 'vacaciones/:id/edit',
                  meta: { label: 'Información de las Vacaciones' },
                  name: 'PersonalNovedadVacacionesEdit',
                  component: PersonalNovedadVacacionesEdit,
                  props: { vacaciones: true },
                },
              ],
            },
            {
              path: 'novedades-calendario',
              meta: { label: 'Calendario de Novedades del Personal' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Calendario de Novedades' },
                  name: 'PersonalNovedadesCalendario',
                  component: PersonalNovedadesCalendario,
                },
              ],
            },
            {
              path: 'viaticos',
              meta: { label: 'Viaticos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Solicitudes de Viaticos' },
                  name: 'Viaticos',
                  component: Viaticos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información de la Solicitud' },
                  name: 'ViaticoAdd',
                  component: ViaticoAdd,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Solicitud' },
                  name: 'ViaticoData',
                  component: ViaticoData,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información de la Solicitud' },
                  name: 'ViaticoEdit',
                  component: ViaticoEdit,
                },
                {
                  path: ':id/pago',
                  meta: { label: 'Pago de Viaticos' },
                  name: 'ViaticoPago',
                  component: ViaticoPago,
                  props: { devolucion: false },
                },
                {
                  path: ':id/devolucion',
                  meta: { label: 'Devolucion de Viaticos' },
                  name: 'ViaticoDevolucion',
                  component: ViaticoDevolucion,
                  props: { devolucion: true },
                },
                {
                  path: ':id/rendicion',
                  meta: { label: 'Rendición de Viaticos' },
                  name: 'ViaticoRendicion',
                  component: ViaticoRendicion,
                },
              ],
            },
            {
              path: 'encuestas',
              meta: { label: 'Encuestas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Encuestas' },
                  name: 'EncuestasUsuarios',
                  component: EncuestasUsuarios,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Encuesta' },
                  name: 'EncuestaUsuarioData',
                  component: EncuestaUsuarioData,
                },
                {
                  path: ':id/completar',
                  meta: { label: 'Información de la Encuesta' },
                  name: 'EncuestaUsuarioCompletar',
                  component: EncuestaUsuarioCompletar,
                },
              ],
            },
          ],
        },

        /* Impuestos */
        {
          path: 'impuestos',
          meta: { label: 'Impuestos' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'organismos',
              meta: { label: 'Organismos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Organismos' },
                  name: 'ImpuestosOrganismos',
                  component: ImpuestosOrganismos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Organismo' },
                  name: 'ImpuestoOrganismoABM',
                  component: ImpuestoOrganismoABM,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Organismo' },
                  name: 'ImpuestoOrganismoDatos',
                  component: ImpuestoOrganismoDatos,
                },
                {
                  path: 'impuestos',
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: ':impuestoOrganismoId',
                      meta: { label: 'Impuestos' },
                      name: 'Impuestos',
                      component: Impuestos,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':impuestoOrganismoId/:id/ABM',
                      meta: { label: 'Información del Impuesto' },
                      name: 'ImpuestoABM',
                      component: ImpuestoABM,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':impuestoOrganismoId/:id',
                      meta: { label: 'Información del Impuesto' },
                      name: 'ImpuestoDatos',
                      component: ImpuestoDatos,
                      beforeEnter: requireAuth,
                    },
                  ],
                },
              ],
            },
            {
              path: 'declaraciones-juradas',
              meta: { label: 'Declaraciones Juradas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'ComprasImpuestos',
                  meta: { label: 'Listado de DD.JJ.' },
                  component: ComprasImpuestos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la DD.JJ.' },
                  name: 'CompraImpuestoData',
                  component: CompraImpuestoData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información de la DD.JJ.' },
                  name: 'CompraImpuestoABM',
                  component: CompraImpuestoABM,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'pagos',
              meta: { label: 'Pagos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'PagosImpuestos',
                  meta: { label: 'Listado de Pagos de Impuestos' },
                  component: PagosImpuestos,
                  beforeEnter: requireAuth,
                  props: { impuestos: true },
                },
                {
                  path: 'ABM',
                  meta: { label: 'Información del Pago de Impuestos' },
                  name: 'PagoImpuestosABM',
                  component: PagoImpuestosABM,
                  beforeEnter: requireAuth,
                  props: { impuestos: true },
                  // props: true
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Pago de Impuestos' },
                  name: 'PagoImpuestosData',
                  component: PagoImpuestosData,
                  beforeEnter: requireAuth,
                  props: { impuestos: true },
                },
              ],
            },
            {
              path: 'estado',
              meta: { label: 'Estado' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'CuentaCorrienteImpuestos',
                  meta: { label: 'Estado de Impuestos' },
                  component: CuentaCorrienteImpuestos,
                  beforeEnter: requireAuth,
                  props: { impuestos: true },
                },
              ],
            },
            {
              path: 'planes-pagos',
              meta: { label: 'Planes de Pago' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'PlanesPagos',
                  meta: { label: 'Listado de Planes de Pago' },
                  component: PlanesPagos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Plan de Pagos' },
                  name: 'PlanPagosABM',
                  component: PlanPagosABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/pago',
                  meta: { label: 'Información del Pago de Cuotas' },
                  name: 'PagoCuotasABM',
                  component: PagoCuotasABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Plan de Pagos' },
                  name: 'PlanPagosData',
                  component: PlanPagosData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        /* PROVEEDORES */
        {
          path: 'proveedores',
          meta: { label: 'Proveedores' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'proveedores',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Proveedores' },
                  name: 'Proveedores',
                  component: Proveedores,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Proveedor' },
                  name: 'ProveedorAdd',
                  component: ProveedorAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Proveedor' },
                  name: 'ProveedorEdit',
                  component: ProveedorEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Proveedor' },
                  name: 'ProveedorDatos',
                  component: ProveedorData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'pagos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'Pagos',
                  meta: { label: 'Listado de Ordenes de Pago' },
                  component: Pagos,
                  beforeEnter: requireAuth,
                  props: { impuestos: false },
                },
                {
                  path: 'ABM',
                  meta: { label: 'Información de la Orden de Pago' },
                  name: 'PagoABM',
                  component: PagoABM,
                  beforeEnter: requireAuth,
                  props: { impuestos: false },
                  // props: true
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Orden de Pago' },
                  name: 'PagoData',
                  component: PagoData,
                  beforeEnter: requireAuth,
                  props: { impuestos: false },
                },
              ],
            },

            {
              path: 'ordenesproveedores',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'OrdenesProveedores',
                  meta: { label: 'Listado de Ordenes a Proveedores' },
                  component: OrdenesProveedores,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'orden-interna',
                  meta: { label: 'Orden de Trabajo Interna' },
                  name: 'OrdenTrabajoInternaABM',
                  component: OrdenTrabajoInternaABM,
                  beforeEnter: requireAuth,
                  props: true,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Orden' },
                  name: 'OrdenProveedorData',
                  component: OrdenProveedorData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Informacion de la Orden' },
                  name: 'OrdenProveedorABM',
                  component: OrdenProveedorABM,
                  beforeEnter: requireAuth,
                  props: true,
                },
              ],
            },

            {
              path: 'cuentacorriente',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'CuentaCorrienteProveedores',
                  meta: { label: 'Cuenta Corriente de Proveedores' },
                  component: CuentaCorrienteProveedores,
                  beforeEnter: requireAuth,
                  props: { impuestos: false },
                },
              ],
            },

            {
              path: 'evaluaciones-proveedores',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'EvaluacionesProveedores',
                  meta: { label: 'Listado de Evaluaciones a Proveedores' },
                  component: EvaluacionesProveedores,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Evaluacion' },
                  name: 'EvaluacionProveedorData',
                  component: EvaluacionProveedorData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        /* TABLAS */
        {
          path: 'tablas',
          meta: { label: 'Tablas' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          children: [
            {
              path: 'articulos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  beforeEnter: requireAuth,
                  name: 'Articulos',
                  meta: { label: 'Listado de Artículos' },
                  component: Articulos,
                },
                {
                  path: ':id/ABM',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Artículo' },
                  name: 'ArticuloABM',
                  component: ArticuloABM,
                },
                {
                  path: ':id',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Artículo' },
                  name: 'ArticuloData',
                  component: ArticuloData,
                },
              ],
            },
            {
              path: 'articulostipos',
              meta: { label: 'Tipos de Artículo' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  beforeEnter: requireAuth,
                  name: 'ArticulosTipos',
                  meta: { label: 'Listado de Tipos de Artículo' },
                  component: ArticulosTipos,
                },
                {
                  path: ':id/ABM',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Tipo de Artículo' },
                  name: 'ArticuloTipoABM',
                  component: ArticuloTipoABM,
                },
                {
                  path: ':id',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Tipo de Artículo' },
                  name: 'ArticuloTipoData',
                  component: ArticuloTipoData,
                },
              ],
            },
            {
              path: 'bancos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'Bancos',
                  meta: { label: 'Listado de Bancos' },
                  component: Bancos,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'ABM de Bancos' },
                  name: 'BancoABM',
                  component: BancoABM,
                },
                {
                  path: ':id',
                  meta: { label: 'Datos del Banco' },
                  name: 'BancoData',
                  component: BancoData,
                },
              ],
            },
            {
              path: 'canales',
              meta: { label: 'Canales' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Canales' },
                  name: 'Canales',
                  component: Canales,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Canal' },
                  name: 'CanalAdd',
                  component: CanalAdd,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Canal' },
                  name: 'CanalEdit',
                  component: CanalEdit,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Canal' },
                  name: 'CanalData',
                  component: CanalData,
                },
              ],
            },

            {
              path: 'cancelacionesmotivos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'CancelacionesMotivos',
                  meta: { label: 'Listado de Motivos de Cancelación' },
                  component: CancelacionesMotivos,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Motivo' },
                  name: 'CancelacionMotivoABM',
                  component: CancelacionMotivoABM,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Motivo' },
                  name: 'CancelacionMotivoData',
                  component: CancelacionMotivoData,
                },
              ],
            },

            {
              path: 'cargos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  beforeEnter: requireAuth,
                  name: 'Cargos',
                  meta: { label: 'Listado de Cargos' },
                  component: Cargos,
                },
                {
                  path: ':id/ABM',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Cargo' },
                  name: 'CargoABM',
                  component: CargoABM,
                },
                {
                  path: ':id',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Cargo' },
                  name: 'CargoData',
                  component: CargoData,
                },
              ],
            },

            {
              path: 'formaspago',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Formas de Pago' },
                  name: 'FormasPago',
                  component: FormasPago,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Actualización de Formas de Pago' },
                  name: 'FormaPagoABM',
                  component: FormaPagoABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Forma de Pago' },
                  name: 'FormaPagoData',
                  component: FormaPagoData,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'giros-empresas',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Giros' },
                  name: 'GirosEmpresas',
                  component: GirosEmpresas,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Giro' },
                  name: 'GiroEmpresaAdd',
                  component: GiroEmpresaAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Giro' },
                  name: 'GiroEmpresaEdit',
                  component: GiroEmpresaEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'marcas',
              meta: { label: 'Marcas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Marcas' },
                  name: 'Marcas',
                  component: Marcas,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información de la Marca' },
                  name: 'MarcaAdd',
                  component: MarcaAdd,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información de la Marca' },
                  name: 'MarcaEdit',
                  component: MarcaEdit,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Marca' },
                  name: 'MarcaData',
                  component: MarcaData,
                },
              ],
            },
            {
              path: 'paises',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Paises' },
                  name: 'Paises',
                  component: Paises,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Pais' },
                  name: 'PaisABM',
                  component: PaisABM,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'provincias',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Provincias' },
                  name: 'Provincias',
                  component: Provincias,
                },
                {
                  path: ':id/ABM',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información de la Provincia' },
                  name: 'ProvinciaABM',
                  component: ProvinciaABM,
                },
                {
                  path: ':id',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información de la Provincia' },
                  name: 'ProvinciaData',
                  component: ProvinciaData,
                },
              ],
            },
            {
              path: 'localidades',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Localidades' },
                  name: 'Localidades',
                  component: Localidades,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información de la Localidad' },
                  name: 'LocalidadABM',
                  component: LocalidadABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Localidad' },
                  name: 'LocalidadData',
                  component: LocalidadData,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'rubros-bienes',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Rubros de Bienes' },
                  name: 'BienesRubros',
                  component: BienesRubros,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Rubro' },
                  name: 'BienRubroAdd',
                  component: BienRubroAdd,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Rubro' },
                  name: 'BienRubroEdit',
                  component: BienRubroEdit,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Rubro' },
                  name: 'BienRubroData',
                  component: BienRubroData,
                },
              ],
            },
            {
              path: 'rubrostrabajos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'RubrosTrabajos',
                  meta: { label: 'Listado de Rubros de Trabajo' },
                  component: RubrosTrabajos,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Rubro Trabajos - ABM' },
                  name: 'RubroTrabajosABM',
                  component: RubroTrabajosABM,
                },
                {
                  path: ':id',
                  meta: { label: 'Rubro Trabajos - Datos' },
                  name: 'RubroTrabajosData',
                  component: RubroTrabajosData,
                },
              ],
            },
            {
              path: 'tareas-estados',
              meta: { label: 'Tareas - Estados' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Estados' },
                  name: 'BriefsTareasEstados',
                  component: BriefsTareasEstados,
                  beforeEnter: requireAuth,
                },
                // {
                //   path: 'add',
                //   meta: { label: 'Información del Estado'},
                //   name: 'BriefTareaEstadoAdd',
                //   component: BriefTareaEstadoAdd,
                // },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Estado' },
                  name: 'BriefTareaEstadoEdit',
                  component: BriefTareaEstadoEdit,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Estado' },
                  name: 'BriefTareaEstadoData',
                  component: BriefTareaEstadoData,
                },
              ],
            },

            {
              path: 'tarjetasmarcas',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'TarjetasMarcas',
                  meta: { label: 'Listado de Marcas de Tarjetas' },
                  component: TarjetasMarcas,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información de la Marca' },
                  name: 'TarjetaMarcaABM',
                  component: TarjetaMarcaABM,
                },
                {
                  path: ':id',
                  meta: { label: 'Información de la Marca' },
                  name: 'TarjetaMarcaData',
                  component: TarjetaMarcaData,
                },
              ],
            },
            {
              path: 'tipos-novedades',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'TiposNovedades',
                  meta: { label: 'Listado de Tipos de Novedades' },
                  component: TiposNovedades,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Tipo de Novedad' },
                  name: 'TipoNovedadABM',
                  component: TipoNovedadABM,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Tipo de Novedad' },
                  name: 'TipoNovedadData',
                  component: TipoNovedadData,
                },
              ],
            },
            {
              path: 'bancosmovimientostipos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Tipos de Movimientos de Banco' },
                  name: 'BancosMovimientosTipos',
                  component: BancosMovimientosTipos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Tipo de Movimiento de Banco' },
                  name: 'BancoMovimientoTipoABM',
                  component: BancoMovimientoTipoABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Tipo de Movimiento' },
                  name: 'BancoMovimientoTipoData',
                  component: BancoMovimientoTipoData,
                  beforeEnter: requireAuth,
                },
              ],
            },
            {
              path: 'tipos-presupuestos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'TiposPresupuestos',
                  meta: { label: 'Listado de Tipos de Presupuesto' },
                  component: TiposPresupuestos,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Tipo de Novedad' },
                  name: 'TipoPresupuestoAdd',
                  component: TipoPresupuestoAdd,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Tipo de Presupuesto' },
                  name: 'TipoPresupuestoEdit',
                  component: TipoPresupuestoEdit,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Tipo de Presupuesto' },
                  name: 'TipoPresupuestoData',
                  component: TipoPresupuestoData,
                },
              ],
            },
            {
              path: 'retencionestipos',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Tipos de Retenciones' },
                  name: 'RetencionesTipos',
                  component: RetencionesTipos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información del Tipo de Retención' },
                  name: 'RetencionTipoABM',
                  component: RetencionTipoABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Tipo de Retención' },
                  name: 'RetencionTipoData',
                  component: RetencionTipoData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'retencionesregimenes',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Regimenes de Retencion' },
                  name: 'RetencionesRegimenes',
                  component: RetencionesRegimenes,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Regimen de Retencion' },
                  name: 'RetencionRegimenABM',
                  component: RetencionRegimenABM,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Datos del Regimen de Retención' },
                  name: 'RetencionRegimenData',
                  component: RetencionRegimenData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'presupuestos-gastos-conceptos',
              meta: { label: 'Conceptos de Presupuestos de Gastos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  beforeEnter: requireAuth,
                  name: 'PresupuestosGastosConceptos',
                  meta: { label: 'Listado de Conceptos' },
                  component: PresupuestosGastosConceptos,
                },
                {
                  path: 'add',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Concepto' },
                  name: 'PresupuestoGastosConceptoAdd',
                  component: PresupuestoGastosConceptoAdd,
                },
                {
                  path: ':id/edit',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Concepto' },
                  name: 'PresupuestoGastosConceptoEdit',
                  component: PresupuestoGastosConceptoEdit,
                },
                {
                  path: ':id',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Concepto' },
                  name: 'PresupuestoGastosConceptoData',
                  component: PresupuestoGastosConceptoData,
                },
              ],
            },

            {
              path: 'etiquetas-proveedores',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Etiquetas' },
                  name: 'EtiquetasProveedores',
                  component: EtiquetasProveedores,
                },
                {
                  path: 'add',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información de la Etiqueta' },
                  name: 'EtiquetaProveedorAdd',
                  component: EtiquetaProveedorAdd,
                },
                {
                  path: ':id/ABM',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información de la Etiqueta' },
                  name: 'EtiquetaProveedorEdit',
                  component: EtiquetaProveedorEdit,
                },
                {
                  path: ':id',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información de la Etiqueta' },
                  name: 'EtiquetaProveedorData',
                  component: EtiquetaProveedorData,
                },
              ],
            },
            {
              path: 'viaticos-rubros',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'ViaticosRubros',
                  meta: { label: 'Listado de Rubros de Viáticos' },
                  component: ViaticosRubros,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Rubro' },
                  name: 'ViaticoRubroAdd',
                  component: ViaticoRubroAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Rubro' },
                  name: 'ViaticoRubroEdit',
                  component: ViaticoRubroEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Rubro' },
                  name: 'ViaticoRubroData',
                  component: ViaticoRubroData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'rubros-intereses-bancarios',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Rubros de Intereses Bancarios' },
                  name: 'InteresesBancariosRubros',
                  component: InteresesBancariosRubros,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Rubro' },
                  name: 'InteresBancarioRubroAdd',
                  component: InteresBancarioRubroAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Rubro' },
                  name: 'InteresBancarioRubroEdit',
                  component: InteresBancarioRubroEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Rubro' },
                  name: 'InteresBancarioRubroData',
                  component: InteresBancarioRubroData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            /* Plan de Cuentas */
            {
              path: 'plan-cuentas',
              meta: { label: 'Cuentas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  name: 'PlanCuentas',
                  meta: { label: 'Plan de Cuentas' },
                  beforeEnter: requireAuth,
                  component: PlanCuentas,
                },
              ],
            },

            {
              path: 'vendedores',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Vendedores' },
                  name: 'Vendedores',
                  component: Vendedores,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Vendedor' },
                  name: 'VendedorAdd',
                  component: VendedorAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Vendedor' },
                  name: 'VendedorEdit',
                  component: VendedorEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Vendedor' },
                  name: 'VendedorData',
                  component: VendedorData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'tipos-disenios',
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'TiposDisenios',
                  meta: { label: 'Listado de Tipos de Diseño' },
                  component: TiposDisenios,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Tipo de Diseño' },
                  name: 'TipoDisenioAdd',
                  component: TipoDisenioAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Tipo de Diseño' },
                  name: 'TipoDisenioEdit',
                  component: TipoDisenioEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Tipo de Diseño' },
                  name: 'TipoDisenioData',
                  component: TipoDisenioData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        /* ADMINISTRACION */
        {
          path: 'administracion',
          meta: { label: 'Administración' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'cajas',
              meta: { label: 'Cajas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: 'cajas',
                  meta: { label: 'Cajas' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: '',
                      name: 'Cajas',
                      meta: { label: 'Listado de Cajas' },
                      component: Cajas,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/ABM',
                      meta: { label: 'Información de la Caja' },
                      name: 'CajaABM',
                      component: CajaABM,
                      beforeEnter: requireAuth,
                    },
                  ],
                },

                {
                  path: 'cajasregistros',
                  meta: { label: 'Cajas - Registros' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: '',
                      name: 'CajasRegistros',
                      meta: { label: 'Listado de Cajas - Registros' },
                      component: CajasRegistros,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/movimientos',
                      meta: { label: 'Movimientos de Caja' },
                      name: 'CajaRegistroMovimientos',
                      component: CajaRegistroMovimientos,
                      beforeEnter: requireAuth,
                    },
                  ],
                },
              ],
            },

            {
              path: 'bancos',
              meta: { label: 'Bancos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: 'bancoscuentas',
                  meta: { label: 'Cuentas Bancarias' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  children: [
                    {
                      path: '',
                      meta: { label: 'Cuentas Bancarias' },
                      name: 'BancosCuentas',
                      component: BancosCuentas,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/ABM',
                      meta: { label: 'Cuenta Bancaria' },
                      name: 'BancoCuentaABM',
                      component: BancoCuentaABM,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id',
                      meta: { label: 'Datos de la Cuenta' },
                      name: 'BancoCuentaData',
                      component: BancoCuentaData,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/saldos',
                      meta: { label: 'Saldos de la Cuenta' },
                      name: 'BancoCuentaSaldos',
                      component: BancoCuentaSaldos,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/cierre',
                      meta: { label: 'Cierre de Movimientos' },
                      name: 'BancoCuentaCierre',
                      component: BancoCuentaCierre,
                      beforeEnter: requireAuth,
                    },
                  ],
                },

                {
                  path: 'bancosmovimientos',
                  meta: { label: 'Movimientos de Banco' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  children: [
                    {
                      path: '',
                      meta: { label: 'Libro Banco' },
                      name: 'BancosMovimientos',
                      component: BancosMovimientos,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/ABM',
                      meta: { label: 'Movimiento de Banco' },
                      name: 'BancoMovimientoABM',
                      component: BancoMovimientoABM,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id',
                      meta: { label: 'Datos del Movimiento' },
                      name: 'BancoMovimientoData',
                      component: BancoMovimientoData,
                      beforeEnter: requireAuth,
                    },
                  ],
                },

                {
                  path: 'bancoschequeras',
                  meta: { label: 'Chequeras' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: '',
                      meta: { label: 'Listado de Chequeras' },
                      name: 'BancosChequeras',
                      component: BancosChequeras,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/ABM',
                      meta: { label: 'Información de la Chequera' },
                      name: 'BancoChequeraABM',
                      component: BancoChequeraABM,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id',
                      meta: { label: 'Información de la Chequera' },
                      name: 'BancoChequeraData',
                      component: BancoChequeraData,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/cheques',
                      meta: { label: 'Cheques Propios' },
                      name: 'BancoChequeraCheques',
                      component: BancoChequeraCheques,
                      beforeEnter: requireAuth,
                    },
                  ],
                },

                {
                  path: 'cheques-propios',
                  meta: { label: 'Cheques Propios' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  children: [
                    {
                      path: '',
                      meta: { label: 'Listado de Cheques' },
                      name: 'ChequesPropios',
                      component: ChequesPropios,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id',
                      meta: { label: 'Datos del Cheque' },
                      name: 'ChequePropioData',
                      component: BancoMovimientoData,
                      beforeEnter: requireAuth,
                    },
                  ],
                },

                {
                  path: 'cheques-terceros',
                  meta: { label: 'Cheques de Terceros' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  beforeEnter: requireAuth,
                  children: [
                    {
                      path: '',
                      meta: { label: 'Cheques de Terceros' },
                      name: 'ChequesTerceros',
                      component: ChequesTerceros,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: 'add',
                      meta: { label: 'Cheque de Terceros' },
                      name: 'ChequeTerceroAdd',
                      component: ChequeTerceroAdd,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id/edit',
                      meta: { label: 'Cheque de Terceros' },
                      name: 'ChequeTerceroEdit',
                      component: ChequeTerceroEdit,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id',
                      meta: { label: 'Datos del Cheque' },
                      name: 'ChequeTerceroData',
                      component: ChequeTerceroData,
                      beforeEnter: requireAuth,
                    },
                  ],
                },

                {
                  path: 'transferencias-premios',
                  meta: { label: 'Transferencias Premios' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  children: [
                    {
                      path: '',
                      meta: { label: 'Listado de Imputaciones de Transferencias' },
                      name: 'TransferenciasPremiosImputaciones',
                      component: TransferenciasPremiosImputaciones,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: 'ABM',
                      meta: { label: 'Imputacion de Transferencias' },
                      name: 'TransferenciasPremiosImputacionABM',
                      component: TransferenciasPremiosImputacionABM,
                      beforeEnter: requireAuth,
                    },
                  ],
                },
              ],
            },

            {
              path: 'bienes',
              meta: { label: 'Bienes' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  meta: { label: 'Bienes' },
                  name: 'Bienes',
                  component: Bienes,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'celulares/add',
                  meta: { label: 'Informacion del Equipo' },
                  name: 'CelularAdd',
                  component: CelularAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'celulares/:id/edit',
                  meta: { label: 'Informacion del Equipo' },
                  name: 'CelularEdit',
                  component: CelularEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'celulares/:id',
                  meta: { label: 'Informacion del Equipo' },
                  name: 'CelularData',
                  component: CelularData,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'computadoras/add',
                  meta: { label: 'Informacion del Equipo' },
                  name: 'ComputadoraAdd',
                  component: ComputadoraAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'computadoras/:id/edit',
                  meta: { label: 'Informacion del Equipo' },
                  name: 'ComputadoraEdit',
                  component: ComputadoraEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'computadoras/:id',
                  meta: { label: 'Informacion del Equipo' },
                  name: 'ComputadoraData',
                  component: ComputadoraData,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Informacion del Bien' },
                  name: 'BienAdd',
                  component: BienAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Informacion del Bien' },
                  name: 'BienEdit',
                  component: BienEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Bien' },
                  name: 'BienData',
                  component: BienData,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'presupuestos-gastos',
              meta: { label: 'Presupuestos de Gastos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: '',
                  meta: { label: 'Presupuestos de Gastos' },
                  name: 'PresupuestosGastos',
                  component: PresupuestosGastos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Informacion del Presupuesto' },
                  name: 'PresupuestoGastosAdd',
                  component: PresupuestoGastosAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'comparativo',
                  beforeEnter: requireAuth,
                  meta: { label: 'Comparativo de Presupuestos' },
                  name: 'PresupuestosGastosComparativo',
                  component: PresupuestosGastosComparativo,
                },
                {
                  path: ':id/duplicar',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Concepto' },
                  name: 'PresupuestoGastosDuplicar',
                  component: PresupuestoGastosDuplicar,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Informacion del Presupuesto' },
                  name: 'PresupuestoGastosEdit',
                  component: PresupuestoGastosEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Presupuesto' },
                  name: 'PresupuestoGastosData',
                  component: PresupuestoGastosData,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        {
          path: 'administracion/tarjetas/tarjetas',
          meta: { label: 'Tarjetas' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'Tarjetas',
              meta: { label: 'Tarjetas' },
              component: Tarjetas,
            },
            {
              path: 'add',
              meta: { label: 'Información de la Tarjeta' },
              name: 'TarjetaAdd',
              component: TarjetaAdd,
            },
            {
              path: ':id/edit',
              meta: { label: 'Información de la Tarjeta' },
              name: 'TarjetaEdit',
              component: TarjetaEdit,
            },
            {
              path: ':tarjetaId/tarjetas-vencimientos',
              meta: { label: 'Vencimientos de Tarjetas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'TarjetasVencimientos',
                  meta: { label: 'Listado de Vencimientos' },
                  component: TarjetasVencimientos,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Vencimiento' },
                  name: 'TarjetaVencimientoAdd',
                  component: TarjetaVencimientoAdd,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Vencimiento' },
                  name: 'TarjetaVencimientoData',
                  component: TarjetaVencimientoData,
                },
              ],
            },
            {
              path: ':tarjetaId/tarjetas-plasticos',
              meta: { label: 'Plásticos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'TarjetasPlasticos',
                  meta: { label: 'Listado de Plasticos' },
                  component: TarjetasPlasticos,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Plastico' },
                  name: 'TarjetaPlasticoAdd',
                  component: TarjetaPlasticoAdd,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Plastico' },
                  name: 'TarjetaPlasticoData',
                  component: TarjetaPlasticoData,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Plastico' },
                  name: 'TarjetaPlasticoEdit',
                  component: TarjetaPlasticoEdit,
                },
              ],
            },
            {
              path: ':id',
              meta: { label: 'Información de la Tarjeta' },
              name: 'TarjetaData',
              component: TarjetaData,
            },
          ],
        },

        {
          path: 'administracion/tarjetas/tarjetas-resumenes',
          meta: { label: 'Resumenes de Tarjetas' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'TarjetasResumenes',
              meta: { label: 'Listado de Resumenes' },
              component: TarjetasResumenes,
              props: { noResumen: false },
            },
            {
              path: ':id',
              meta: { label: 'Información del Resumen' },
              name: 'TarjetaResumenData',
              component: TarjetaResumenData,
              props: { noResumen: false },
            },
            {
              path: ':tarjetaResumenId/pagos',
              meta: { label: 'Pagos de Resumenes' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Pagos del Resumen' },
                  name: 'TarjetaResumenPagos',
                  component: TarjetaResumenPagos,
                },
                {
                  path: 'add',
                  meta: { label: 'Pago de Resumen' },
                  name: 'TarjetaResumenPago',
                  component: TarjetaResumenPago,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Pago' },
                  name: 'TarjetaResumenPagoData',
                  component: TarjetaResumenPagoData,
                },
              ],
            },
          ],
        },

        {
          path: 'administracion/tarjetas/tarjetas-no-resumen',
          meta: { label: 'Cartera de Cupones' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'TarjetasResumenesNoResumen',
              meta: { label: 'Listado de Cupones' },
              component: TarjetasResumenesNoResumen,
              props: { noResumen: true },
            },
            {
              path: ':tarjetaId',
              meta: { label: 'Información del Resumen' },
              name: 'TarjetaResumenDataNoResumen',
              component: TarjetaResumenDataNoResumen,
              props: { noResumen: true },
            },
          ],
        },

        {
          path: 'administracion/tarjetas/tarjetas-cupones',
          meta: { label: 'Cupones de Tarjetas' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'TarjetasCupones',
              meta: { label: 'Cupones de Tarjetas' },
              component: TarjetasCupones,
            },
            {
              path: ':id/ABM',
              meta: { label: 'Información del Cupón' },
              name: 'TarjetaCuponABM',
              component: TarjetaCuponABM,
            },
            {
              path: ':id',
              meta: { label: 'Información del Cupón' },
              name: 'TarjetaCuponData',
              component: TarjetaCuponData,
            },
          ],
        },

        {
          path: 'administracion/flujo-fondos',
          meta: { label: 'Flujo de Fondos' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'flujo',
              meta: { label: 'Flujo de Fondos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  beforeEnter: requireAuth,
                  meta: { label: 'Flujo' },
                  name: 'FlujoFondos',
                  component: FlujoFondos,
                },
              ],
            },
            {
              path: 'presupuestos',
              meta: { label: 'Presupuestos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  beforeEnter: requireAuth,
                  meta: { label: 'Listado de Presupuestos' },
                  name: 'FlujoFondosPresupuestos',
                  component: FlujoFondosPresupuestos,
                },
                {
                  path: 'add',
                  beforeEnter: requireAuth,
                  meta: { label: 'Información del Presupuesto' },
                  name: 'FlujoFondosPresupuestoAdd',
                  component: FlujoFondosPresupuestoAdd,
                },
              ],
            },
          ],
        },

        {
          path: 'administracion/vendedores',
          meta: { label: 'Vendedores' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'cuenta-corriente',
              beforeEnter: requireAuth,
              meta: { label: 'Cuenta Corriente' },
              name: 'VendedorCuentaCorriente',
              component: VendedorCuentaCorriente,
              props: { comisionesCobros: false },
            },
            {
              path: 'cuenta-corriente-cobros',
              beforeEnter: requireAuth,
              meta: { label: 'Cuenta Corriente por Cobros' },
              name: 'VendedorCuentaCorrienteCobros',
              component: VendedorCuentaCorrienteCobros,
              props: { comisionesCobros: true },
            },            
          ],
        },

        {
          path: 'administracion/parametros',
          meta: { label: 'Parámetros' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'gral',
              beforeEnter: requireAuth,
              meta: { label: 'Parámetros' },
              name: 'Parametros',
              component: Parametros,
            },
            {
              path: 'fe',
              beforeEnter: requireAuth,
              meta: { label: 'Factura Electrónica' },
              name: 'FacturaElectronica',
              component: FacturaElectronica,
            },
            {
              path: 'empresa',
              beforeEnter: requireAuth,
              meta: { label: 'Empresa' },
              name: 'Empresa',
              component: Empresa,
            },
            {
              path: 'inflacion',
              meta: { label: 'Parámetros de Inflación' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Parámetros' },
                  name: 'ParametrosInflacion',
                  component: ParametrosInflacion,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/ABM',
                  meta: { label: 'Información de Inflación' },
                  name: 'ParametroInflacionABM',
                  component: ParametroInflacionABM,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        {
          path: 'administracion/indicadores',
          meta: { label: 'Indicadores' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'gastos',
              meta: { label: 'Indicadores de Gastos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresGastos',
                  component: IndicadoresGastos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorGastosAdd',
                  component: IndicadorGastosAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorGastosData',
                  component: IndicadorGastosData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorGastosEdit',
                  component: IndicadorGastosEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'gastos-ventas',
              meta: { label: 'Indicadores de Gastos/Ventas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresGastosVentas',
                  component: IndicadoresGastosVentas,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorGastosVentasAdd',
                  component: IndicadorGastosVentasAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorGastosVentasData',
                  component: IndicadorGastosVentasData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorGastosVentasEdit',
                  component: IndicadorGastosVentasEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'compras-ventas',
              meta: { label: 'Indicadores de Compras/Ventas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresComprasVentas',
                  component: IndicadoresComprasVentas,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorComprasVentasAdd',
                  component: IndicadorComprasVentasAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorComprasVentasData',
                  component: IndicadorComprasVentasData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorComprasVentasEdit',
                  component: IndicadorComprasVentasEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'plazo',
              meta: { label: 'Indicadores de Diferencia de Plazos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresPlazo',
                  component: IndicadoresPlazo,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoAdd',
                  component: IndicadorPlazoAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoData',
                  component: IndicadorPlazoData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoEdit',
                  component: IndicadorPlazoEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'plazo-proveedores-semestral',
              meta: { label: 'Indicadores de Plazo de Pago' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresPlazoProveedoresSemestral',
                  component: IndicadoresPlazoProveedoresSemestral,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoProveedoresSemestralAdd',
                  component: IndicadorPlazoProveedoresSemestralAdd,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoProveedoresSemestralData',
                  component: IndicadorPlazoProveedoresSemestralData,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoProveedoresSemestralEdit',
                  component: IndicadorPlazoProveedoresSemestralEdit,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'plazo-proveedores-anual',
              meta: { label: 'Indicadores de Plazo de Pago' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresPlazoProveedoresAnual',
                  component: IndicadoresPlazoProveedoresAnual,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoProveedoresAnualAdd',
                  component: IndicadorPlazoProveedoresAnualAdd,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoProveedoresAnualData',
                  component: IndicadorPlazoProveedoresAnualData,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoProveedoresAnualEdit',
                  component: IndicadorPlazoProveedoresAnualEdit,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'plazo-clientes',
              meta: { label: 'Indicadores de Plazo de Cobro' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresPlazoClientes',
                  component: IndicadoresPlazoClientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoClientesAdd',
                  component: IndicadorPlazoClientesAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoClientesData',
                  component: IndicadorPlazoClientesData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorPlazoClientesEdit',
                  component: IndicadorPlazoClientesEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'rentabilidad-anual',
              meta: { label: 'Indicadores de Rentabilidad Bruta' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresRentabilidadAnual',
                  component: IndicadoresRentabilidadAnual,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadAnualAdd',
                  component: IndicadorRentabilidadAnualAdd,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadAnualData',
                  component: IndicadorRentabilidadAnualData,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadAnualEdit',
                  component: IndicadorRentabilidadAnualEdit,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
              ],
            },

            {
              path: 'rentabilidad-semestral',
              meta: { label: 'Indicadores de Rentabilidad Bruta' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresRentabilidadSemestral',
                  component: IndicadoresRentabilidadSemestral,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadSemestralAdd',
                  component: IndicadorRentabilidadSemestralAdd,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadSemestralData',
                  component: IndicadorRentabilidadSemestralData,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadSemestralEdit',
                  component: IndicadorRentabilidadSemestralEdit,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
              ],
            },

            {
              path: 'rentabilidad-neta-anual',
              meta: { label: 'Indicadores de Rentabilidad Neta' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresRentabilidadNetaAnual',
                  component: IndicadoresRentabilidadNetaAnual,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadNetaAnualAdd',
                  component: IndicadorRentabilidadNetaAnualAdd,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadNetaAnualData',
                  component: IndicadorRentabilidadNetaAnualData,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadNetaAnualEdit',
                  component: IndicadorRentabilidadNetaAnualEdit,
                  beforeEnter: requireAuth,
                  props: { semestral: false },
                },
              ],
            },

            {
              path: 'rentabilidad-neta-semestral',
              meta: { label: 'Indicadores de Rentabilidad Neta' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresRentabilidadNetaSemestral',
                  component: IndicadoresRentabilidadNetaSemestral,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadNetaSemestralAdd',
                  component: IndicadorRentabilidadNetaSemestralAdd,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadNetaSemestralData',
                  component: IndicadorRentabilidadNetaSemestralData,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRentabilidadNetaSemestralEdit',
                  component: IndicadorRentabilidadNetaSemestralEdit,
                  beforeEnter: requireAuth,
                  props: { semestral: true },
                },
              ],
            },

            {
              path: 'co4',
              meta: { label: 'Indicadores de CO4' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresRSE',
                  component: IndicadoresRSE,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRSEAdd',
                  component: IndicadorRSEAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRSEData',
                  component: IndicadorRSEData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorRSEEdit',
                  component: IndicadorRSEEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'ventas',
              meta: { label: 'Indicadores de Ventas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresVentas',
                  component: IndicadoresVentas,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasAdd',
                  component: IndicadorVentasAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasData',
                  component: IndicadorVentasData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasEdit',
                  component: IndicadorVentasEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'ventas-mix-semestral',
              meta: { label: 'Indicadores de Ventas - Mix de Clientes' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresVentasMixClientesSemestral',
                  component: IndicadoresVentasMixClientesSemestral,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasMixClientesSemestralAdd',
                  component: IndicadorVentasMixClientesSemestralAdd,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasMixClientesSemestralData',
                  component: IndicadorVentasMixClientesSemestralData,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasMixClientesSemestralEdit',
                  component: IndicadorVentasMixClientesSemestralEdit,
                  props: { semestral: true },
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'ventas-mix-anual',
              meta: { label: 'Indicadores de Ventas - Mix de Clientes' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresVentasMixClientesAnual',
                  component: IndicadoresVentasMixClientesAnual,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasMixClientesAnualAdd',
                  component: IndicadorVentasMixClientesAnualAdd,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasMixClientesAnualData',
                  component: IndicadorVentasMixClientesAnualData,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasMixClientesAnualEdit',
                  component: IndicadorVentasMixClientesAnualEdit,
                  props: { semestral: false },
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'ventas-trimestral',
              meta: { label: 'Indicadores de Ventas Trimestrales' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  meta: { label: 'Listado de Indicadores' },
                  name: 'IndicadoresVentasTrimestral',
                  component: IndicadoresVentasTrimestral,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasTrimestralAdd',
                  component: IndicadorVentasTrimestralAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasTrimestralData',
                  component: IndicadorVentasTrimestralData,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Información del Indicador' },
                  name: 'IndicadorVentasTrimestralEdit',
                  component: IndicadorVentasTrimestralEdit,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },

        {
          path: 'seguridad/usuarios',
          meta: { label: 'Usuarios' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'Usuarios',
              component: Usuarios,
              beforeEnter: requireAuth,
            },
            {
              path: 'add',
              meta: { label: 'Información del Usuario' },
              name: 'UsuarioAdd',
              component: UsuarioAdd,
              beforeEnter: requireAuth,
            },
            {
              path: ':id/edit',
              meta: { label: 'Información del Usuario' },
              name: 'UsuarioEdit',
              component: UsuarioEdit,
              beforeEnter: requireAuth,
            },
            {
              path: ':id',
              meta: { label: 'Información del Usuario' },
              name: 'UsuarioData',
              component: UsuarioData,
              beforeEnter: requireAuth,
            },
            {
              path: '/perfil',
              meta: { label: 'Perfil' },
              name: 'UsuarioPerfil',
              component: UsuarioPerfil,
            },
            {
              path: 'pass',
              meta: { label: 'Actualizar Password' },
              name: 'UsuarioPass',
              component: UsuarioPass,
              beforeEnter: requireAuth,
              props: true,
            },
            {
              path: 'self-pass',
              meta: { label: 'Actualizar Password' },
              name: 'UsuarioSelfPass',
              component: UsuarioPass,
              /*beforeEnter: requireUser,*/
              props: true,
            },
          ],
        },

        {
          path: 'reportes',
          meta: { label: 'Reportes' },
          component: {
            render(c) {
              return c('router-view')
            },
          },
          children: [
            {
              path: 'ventas',
              meta: { label: 'Ventas' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                {
                  path: 'presupuestosinternos',
                  meta: { label: 'Resumen de Presupuestos Internos' },
                  name: 'RptPresupuestosInternos',
                  component: RptPresupuestosInternos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'presupuestos-internos-premios',
                  meta: { label: 'Resumen de Presupuestos Internos - Premios' },
                  name: 'RptPresupuestosInternosPremios',
                  component: RptPresupuestosInternosPremios,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'presupuestos-internos-aperturas-cierres',
                  meta: { label: 'Resumen de Aperturas/Cierres de Presupuestos Internos' },
                  name: 'RptPresupuestosInternosAperturasCierres',
                  component: RptPresupuestosInternosAperturasCierres,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'presupuestos-internos-cancelados',
                  meta: { label: 'Resumen de Presupuestos Internos Cancelados' },
                  name: 'RptPresupuestosInternosCancelados',
                  component: RptPresupuestosInternosCancelados,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'presupuestos-internos-cerrados',
                  meta: { label: 'Resumen de Presupuestos Internos Cerrados' },
                  name: 'RptPresupuestosInternosCerrados',
                  component: RptPresupuestosInternosCerrados,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ventas',
                  meta: { label: 'Resumen de Ventas' },
                  name: 'RptVentas',
                  component: RptVentas,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ventas-comparativo',
                  meta: { label: 'Resumen Comparativo de Ventas' },
                  name: 'RptVentasComparativo',
                  component: RptVentasComparativo,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ventas-resumen-clientes',
                  meta: { label: 'Resumen de Ventas x Cliente' },
                  name: 'RptVentasResumenClientes',
                  component: RptVentasResumenClientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'vendedores-comisiones',
                  meta: { label: 'Resumen de Comisiones' },
                  name: 'RptVendedoresComisiones',
                  component: RptVendedoresComisiones,
                  beforeEnter: requireAuth,
                  props: { comisionesInternas: false },
                },
                {
                  path: 'vendedores-comisiones-resumen',
                  meta: { label: 'Resumen de Comisiones x Vendedor' },
                  name: 'ResumenComisionesVendedor',
                  component: ResumenComisionesVendedor,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'comisiones-internas',
                  meta: { label: 'Resumen de Comisiones Internas' },
                  name: 'RptVendedoresComisionesInternas',
                  component: RptVendedoresComisionesInternas,
                  beforeEnter: requireAuth,
                  props: { comisionesInternas: true },
                },
                {
                  path: 'vendedores-comisiones-cobros-resumen',
                  meta: { label: 'Resumen de Comisiones' },
                  name: 'ResumenComisionesCobrosVendedor',
                  component: ResumenComisionesCobrosVendedor,
                  beforeEnter: requireAuth,
                  props: { comisionesInternas: false },
                },
              ],
            },
            {
              path: 'compras',
              meta: { label: 'Compras' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              children: [
                // {
                //   path: 'compras',
                //   meta: { label: 'Resumen de Compras'},
                //   name: 'RptCompras',
                //   component: RptCompras,
                //   beforeEnter: requireAuth,
                // },
                {
                  path: 'compras-gastos',
                  meta: { label: 'Resumen de Compras-Gastos' },
                  name: 'RptComprasGastos',
                  component: RptComprasGastos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'percepciones',
                  meta: { label: 'Resumen de Percepciones de Compras' },
                  name: 'RptPercepcionesCompras',
                  component: RptPercepcionesCompras,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'compras-fecha',
                  meta: { label: 'Control de Compras' },
                  name: 'RptComprasFecha',
                  component: RptComprasFecha,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ordenes-remitos',
                  meta: { label: 'Resumen de Ordenes-Remitos' },
                  name: 'RptOrdenesRemitos',
                  component: RptOrdenesRemitos,
                  beforeEnter: requireAuth,
                },
                // {
                //   path: 'resumen-gastos',
                //   meta: { label: 'Resumen de Gastos'},
                //   name: 'ResumenGastos',
                //   component: ResumenGastos,
                //   beforeEnter: requireAuth,
                // },
                {
                  path: 'resumen-gastos',
                  meta: { label: '' },
                  component: {
                    render(c) {
                      return c('router-view')
                    },
                  },
                  children: [
                    {
                      path: '',
                      name: 'ResumenGastos',
                      meta: { label: 'Resumen de Gastos' },
                      beforeEnter: requireAuth,
                      component: ResumenGastos,
                      props: true,
                    },
                    {
                      path: ':id',
                      beforeEnter: requireAuth,
                      name: 'ResumenGastosDatos',
                      meta: { label: 'Información del Comprobante' },
                      component: CompraData,
                      props: { routedFrom: 'ResumenGastos' },
                    },
                  ],
                },
              ],
            },

            {
              path: 'clientes',
              meta: { label: 'Clientes' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: 'contactos',
                  meta: { label: 'Listado de Contactos de Clientes' },
                  name: 'RptClientesContactos',
                  component: RptClientesContactos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'deuda',
                  meta: { label: 'Resumen de Deuda de Clientes' },
                  name: 'RptDeudaClientes',
                  component: RptDeudaClientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'cobros',
                  meta: { label: 'Resumen de Órdenes de Cobro' },
                  name: 'RptCobros',
                  component: RptCobros,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'plazos',
                  meta: { label: 'Resumen de Plazos de Cobro' },
                  name: 'RptPlazosClientes',
                  component: RptPlazosClientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'retenciones',
                  meta: { label: 'Resumen de Retenciones de Clientes' },
                  name: 'RptRetencionesClientes',
                  component: RptRetencionesClientes,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'proveedores',
              meta: { label: 'Proveedores' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: 'deuda',
                  meta: { label: 'Resumen de Deuda de Proveedores' },
                  name: 'RptDeudaProveedores',
                  component: RptDeudaProveedores,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ordenes-pendientes',
                  meta: { label: 'Resumen de Ordenes Pendientes' },
                  name: 'RptOrdenesProveedoresPendientes',
                  component: RptOrdenesProveedoresPendientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'plazos',
                  meta: { label: 'Resumen de Plazos de Pago' },
                  name: 'RptPlazosProveedores',
                  component: RptPlazosProveedores,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'pagos',
                  meta: { label: 'Resumen de Órdenes de Pago' },
                  name: 'RptPagos',
                  component: RptPagos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'ordenes-rentabilidad-negativa',
                  meta: { label: 'Resumen de Órdenes Negativas' },
                  name: 'RptOrdenesNegativas',
                  component: RptOrdenesNegativas,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'administracion',
              meta: { label: 'Administración' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                // {
                //   path: 'flow',
                //   meta: { label: 'Flujo de Fondos'},
                //   name: 'FlujoFondos',
                //   component: FlujoFondos,
                // },
                {
                  path: 'holistor-ventas',
                  beforeEnter: requireAuth,
                  meta: { label: 'Holistor - Ventas' },
                  name: 'RptHolistorVentas',
                  component: RptHolistorVentas,
                },
              ],
            },

            {
              path: 'bancos',
              meta: { label: 'Bancos' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: 'ingresos-gastos',
                  meta: { label: 'Reporte Ingresos vs Gastos' },
                  name: 'RptIngresosGastos',
                  component: RptIngresosGastos,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'rrhh',
              meta: { label: 'RRHH' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: 'evolucion-sueldos',
                  meta: { label: 'Evolucion de Sueldos' },
                  name: 'RptEvolucionSueldos',
                  component: RptEvolucionSueldos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'encuestas-usuarios',
                  meta: { label: 'Encuestas de Usuarios' },
                  name: 'RptEncuestasUsuarios',
                  component: RptEncuestasUsuarios,
                  beforeEnter: requireAuth,
                },
              ],
            },

            {
              path: 'logistica',
              meta: { label: 'Logistica' },
              component: {
                render(c) {
                  return c('router-view')
                },
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: 'resumen-remitos',
                  meta: { label: 'Resumen de Remitos' },
                  name: 'RptResumenRemitos',
                  component: RptResumenRemitos,
                  beforeEnter: requireAuth,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        },
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
        },
        {
          path: 'empresa',
          name: 'LoginEmpresa',
          component: LoginEmpresa,
          props: true,
        },
        {
          path: 'registro',
          name: 'Registro',
          component: Registro,
          props: { register: true },
        },
        {
          path: 'forgot',
          name: 'ForgotPassword',
          component: ForgotPassword,
        },
        {
          path: 'reset-pwd',
          name: 'ResetPassword',
          component: ResetPassword,
          props: { register: false },
        },
        {
          path: 'pwd',
          name: 'UpdatePassword',
          component: UpdatePassword,
          props: true,
        },
      ],
    },
  ],
})

router.afterEach(() => {
  window.sessionStorage.removeItem('sgc:router-reloaded-after-async-error')
  clearRecoverQueryParam()
})

router.onError((error) => {
  const recoverable = isRecoverableAsyncComponentError(error)

  if (!recoverable) {
    return
  }

  const reloadKey = 'sgc:router-reloaded-after-async-error'
  const now = Date.now()
  const lastReloadTs = parseInt(window.sessionStorage.getItem(reloadKey) || '0', 10)
  if (!Number.isNaN(lastReloadTs) && now - lastReloadTs < 10000) {
    return
  }

  window.sessionStorage.setItem(reloadKey, String(now))
  forceReloadBypassingCache()
})

export default router
